webpackJsonp([1],{

/***/ "/Se+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EoUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d537ae3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("SU9I")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-7d537ae3"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b14104b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("/Se+")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a70983b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("bMw6")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9212cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("EoUh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  guid: "437c4aa5-0410-47e4-b976-27dbfeda165b",
  title: "Escrime XXI - Issue 113",
  shortTitle: "",
  description: "",
  width: 1532,
  height: 1149,
  currentLanguage: "EN",
  languages: [{
    code: "EN",
    text: "English",
    href: "http://escrime-xxi.fie.org/113/en"
  }, {
    code: "FR",
    text: "French",
    href: "http://escrime-xxi.fie.org/113/fr"
  }, {
    code: "ES",
    text: "German",
    href: "http://escrime-xxi.fie.org/113/es"
  }],
  basePath: "/113/en",
  // basePath: "",
  companyLogo: "1-numeral.jpg",
  publishURL: "http://escrime-xxi.fie.org/113/en/static/_thumbs/",
  externalResources: ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  options: {
    doublePage: false,
    rightToLeft: false,
    searchEnabled: true,
    downloadEnabled: false,
    downloadPath: "",
    printEnabled: false,
    zoomEnabled: true,
    contentsEnabled: true,
    languagesEnabled: false,
    mobileSwitch: true,
    guideEnabled: false,
    galleryCaptions: {}
  },
  pages: [[{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 0,
    subIndex: 0,
    startIndex: 0,
    original: "pg1.jpg",
    zoom: null,
    content: "\n        <img id=\"1-0\" class=\"halfScale\" style=\"top:0px;left:371px\" src=\"/113/en/static/_content/1-numeral.png\">\n        \n        <img id=\"1-1\" class=\"halfScale\" style=\"top:110px;left:0px\" src=\"/113/en/static/_content/1-title.png\">\n        <img id=\"1-2\" class=\"halfScale\" style=\"top:275px;left:68px\" src=\"/113/en/static/_content/1-sub-1.png\">\n\n        <img id=\"1-3\" class=\"halfScale\" style=\"top:111px;left:1075px\" src=\"/113/en/static/_content/1-issue.png\">\n\n        <img id=\"1-text-1\" class=\"halfScaleR pointer\" style=\"top:389px;right:0px\" onclick=\"Publish.goToPage(40)\" src=\"/113/en/static/_content/1-sub-2.png\">\n        <img id=\"1-text-2\" class=\"halfScaleR pointer\" style=\"top:542px;right:0px\" onclick=\"Publish.goToPage(45)\" src=\"/113/en/static/_content/1-sub-3.png\">\n        <img id=\"1-text-3\" class=\"halfScaleR pointer\" style=\"top:657px;right:0px\" onclick=\"Publish.goToPage(54)\" src=\"/113/en/static/_content/1-sub-4.png\">\n\n        <img id=\"1-4\" class=\"halfScale pointer\" style=\"top:988px;left:1442px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/1-arrow.png\">\n\n        ",
    script: "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n          .fromTo(idOf(\"1-1\"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)\n          .fromTo(idOf(\"1-0\"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},\"-=0.2\")\n          .fromTo(idOf(\"1-2\"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-3\"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-text-1\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-2\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-3\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-4\"), 0.5, {x:-60, opacity:0}, {x:0, opacity:1})\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <img src=\"/113/en/static/_mobile/pg1.jpg\">\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 1,
    subIndex: 0,
    startIndex: 0,
    original: "pg2.jpg",
    zoom: null,
    content: "\n\n      <img class=\"halfScale 2-title\" style=\"top:82px;left:84px\" src=\"/113/en/static/_content/2-title.png\">\n\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:169px\" src=\"/113/en/static/_content/2-pop.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:865px;left:448px\" src=\"/113/en/static/_content/2-play.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:865px;left:809px\" src=\"/113/en/static/_content/2-soc.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:865px;left:1136px\" src=\"/113/en/static/_content/2-no.png\">\n\n      <img class=\"halfScale pointer howto-desktop\" style=\"top:125px;left:910px;opacity:1;\" onclick=\"switchPopHowto(true)\" src=\"/113/en/static/_content/2-desktop-btn.png\">\n      <img class=\"halfScale pointer howto-ipad\" style=\"top:125px;left:1112px;opacity:0\" onclick=\"switchPopHowto(false)\" src=\"/113/en/static/_content/2-ipad-btn.png\">\n\n      <img class=\"halfScale howto-desktop\" style=\"top:257px;left:85px;\" src=\"/113/en/static/_content/2-desktop.png\">\n      <img class=\"halfScale howto-ipad\" style=\"top:250px;left:71px;display:none;\" src=\"/113/en/static/_content/2-ipad.png\">\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    script: "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax()\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .staggerFromTo(cOf(\"2-icons\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, \"-=0.2\")\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop()\n          removeContentLinks()\n        }\n      ",
    searchText: "HOW TO USE  Click to change view  HOW TO USE  DESKTOP  Escrime XXI The Fencing Magazine uses the latest digital technology - here are some of the exciting features to enjoy.  IPAD  BROWSING Use the arrows on your keypad to navigate horizontally through the magazine  Navigation To view the magazine, use the arrows on your keypad to travel left and right through the publication.  BROWSER For the best results, we recommend using Safari or Google Chrome  EXPLORE  ide... Hotspots ins  1 2 3 POP UPS  PLAY BUTTON  SOCIAL MEDIA  NUMBERS  Press to reveal, and hide, nuggets of information.  This magazine features great video. Pushing this will launch one.  Press the social media icons found throughout the magazine  Push the buttons to reveal more exciting content.  W W W.FIE .ORG"
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 2,
    subIndex: 0,
    startIndex: 0,
    original: "pg3.jpg",
    zoom: null,
    content: "\n          <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:24px;right:40px;width:280px; height:30px;\"></div>\n          </a>",
    script: "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg3.jpg\">\n      </a>\n\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 3,
    subIndex: 0,
    startIndex: 0,
    original: "pg4.jpg",
    zoom: null,
    content: "\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 191px; left:80px;width:145px; height: 35px;\">\n          <a href=\"http://www.fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top: 82px; right:627px;width:44px; height: 43px;\">\n          <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top:131px; right:626px;width:45px; height: 43px;\">\n          <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\"></a></div>\n\n        <img id=\"4-title\" class=\"halfScale\" style=\"top:81px;left:80px\" src=\"/113/en/static/_content/4-title.png\">\n\n        <img id=\"fourIpad\" class=\"cont-item-0-link halfScale\" style=\"top:386px;left:591px\" src=\"/113/en/static/_content/4-ipad.png\">\n        <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:327.7px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-editorial.png\">\n        <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:267px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-sport.png\">\n        <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:267px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-congress.png\">\n        <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:266.5px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-interview.png\">\n        <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:352px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-federations.png\">\n        <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:328px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-eurosport.png\">\n        <img class=\"cont-item cont-item-7-btn halfScale\" style=\"top:328px;left:574px;opacity:0\" src=\"/113/en/static/_content/4-obituaries.png\">\n\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:940px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/4-arrow.png\">\n\n        <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top:358px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top:450px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(3);\" style=\"top:543px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top:635px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top:727px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top:819px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(7);\" style=\"top:911px; left:84px; width: 492px; height: 60px;\"></div>\n\n        <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\" style=\"top:357px;left:576px;width:638px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\" style=\"top:266px;left:650px;width:700px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(11)\" style=\"top:357px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(15)\" style=\"top:449px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(17)\" style=\"top:541px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(21)\" style=\"top:634px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(24)\" style=\"top:724px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(28)\" style=\"top:816px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(33)\" style=\"top:908px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(35)\" style=\"top:1000px;left:650px;width:701px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(40)\" style=\"top:541px;left:574px;width:597px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(45)\" style=\"top:633px;left:576px;width:595px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(48)\" style=\"top:450px;left:650px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(50)\" style=\"top:542px;left:650px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(54)\" style=\"top:632px;left:650px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(58)\" style=\"top:724px;left:576px;width:755px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(62)\" style=\"top:817px;left:576px;width:776px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(63)\" style=\"top:910px;left:576px;width:776px;height:64px;display:none;\"></div>\n      ",
    script: "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        \n        pg4Anim.fromTo(idOf(\"4-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)\n        .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n      }\n  \n  \n      function contentsBub(index){\n       \n        console.log(\"contentsBub\", index)\n        for(var i=0; i <= 7; i++){\n          if(i == index){\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n              console.log(c)\n              c.style.display = \"\";\n            },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:1, onComplete:function(){\n              \n              classc(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n              if(classc(\"cont-item-\"+index+\"-link\")[1]){\n                classc(\"cont-item-\"+index+\"-link\")[1].style.display = \"\" \n              }\n            }});\n          }else{\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"none\";\n              },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:0});\n\n          }\n        }\n      }\n  \n      function onPageLeave() {\n        pg4Anim.stop()\n        removeContentLinks();\n        contentsBub(0);\n        TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});\n      }\n      ",
    searchText: "THIS ISSUE  Welcome to the latest edition of Escrime XXI, packed with the best fencing images, video and features and showcased in a striking new look.  WWW.FIE.ORG  EDITORIAL  SPORT  Tap buttons to reveal content  CONGRESS  INTERVIEW  FIE & NATIONAL FEDERATIONS NEWS  EUROSPORT VLOG  W W W.FIE .ORG"
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 4,
    subIndex: 0,
    startIndex: 0,
    original: "pg5.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale pointer 5-arrow\" style=\"top:854px;left:1386px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/5-arrow.png\">\n\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1012px;left:54px\" src=\"/113/en/static/_content/white-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1012px;left:123px\" src=\"/113/en/static/_content/white-facebook.png\">\n        </a>\n        <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1012px;left:193px\" src=\"/113/en/static/_content/white-yt.png\">\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        \n        <a href=\"mailto:info@fie.ch\">\n          <div class=\"contentLinkNone\" style=\"bottom:241px;right:692px;width:154px; height:25px;\"></div>\n        </a>\n        <a href=\"http://www.touchline.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:178px;right:307px;width:309px; height:30px;\"></div>\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:212px;right:746px;width:98px; height:25px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax()\n          pg5Anim\n            .fromTo(cOf(\"5-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop()\n        }\n      ",
    searchText: "LIST OF C OME X  President: Alisher Usmanov (RUS) Secretary General: Emmanuel Katsiadakis (M.H.) (GRE) Secretary Treasurer: Ferial Nadira Salhi (ALG)  FIE HEAD OFFICE  Vice Presidents: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Members: Erika Aze (LAT) Jacek Bierkowski (POL) Ana Irene Delgado Guerra (PAN) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Aldo Montano President of the FIE athletes’ commission (ITA)  Administration  President, African Fencing Confederation: Mbagnick Ndiaye (SEN) President, Pan-American Fencing Confederation: Vitaly Logvin (MEX) President, Asian Fencing Confederation: Celso L. Dayrit (M.H.) (PHI) President, European Fencing Confederation: Stanislav Pozdnyakov (RUS) President, Oceanian Fencing Confederation: Helen Smith (M.H.) (AUS)  Nina Lalovic (SRB)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Chief Executive Officer Nathalie Rodriguez M.-H. (FRA)  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Administration Director: Elena Murdaca (ITA) Accounting Manager: Sandra Baroni (SUI) Assistant to the Director: Gabrielle Meylan (BRA) Administrative Assistant: Ylenia Murdaca (ITA) Head of Operations: Elena Huot (RUS) Sport  Sport and Technical Director: Evgeny Tsoukhlo (RUS)  Sport Technology and Administration Manager: Natalia Bodrova (RUS)  Sport Operation Manager: Sophie Treyvaud (SUI) Communication, Marketing, TV  Head of FIE President’s Cabinet: Digital Communications Manager: Maria Ntanou (GRE)  Head of FIE TV Production: Barna Heder (HUN)  FIE TV Production Assistant: Svetlana Krasnokoutskaya (RUS) Press Officer: Serge Timacheff (USA) Photographer: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
    mobileHtml: "\n      <p>\n      <b>President</b>:<br> Alisher Usmanov (RUS)<br>\n      <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>\n      <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>\n      <p>\n      <b>Vice Presidents</b>:<br>\n      Ana Pascu (M.H.) (ROU)<br>\n      Donald Anthony (USA)<br>\n      Yuki Ota (JPN)<br></p>\n      <p>\n      <b>Members</b>:<br>\n      Erika Aze (LAT)<br>\n      Jacek Bierkowski (POL)<br>\n      Velichka Hristeva (BUL)<br>\n      Isabelle Lamour (FRA)<br>\n      Novak Perovic (RSA)<br>\n      Oleg Peskov (KAZ)<br>\n      Giorgio Scarso (ITA)<br>\n      Bence Szabo (HUN)<br>\n      Pascal Tesch (LUX)<br>\n      Wei WANG (CHN)<br>\n      Aldo Montano President of the FIE athletes commission (ITA)<br></p>\n\n      <p>\n        <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>\n        <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>\n        <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>\n        <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>\n        <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>\n      </p>\n      \n      <h2>FIE Head Office</h2>\n      <p>\n      <b>Chief Executive Officer</b><br>\n      Nathalie Rodriguez M.-H. (FRA)\n      </p>\n\n      <h2>Administration</h2>\n      <p>\n      <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>\n      <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>\n      <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>\n      <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>\n      <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>\n      </p>\n\n      <h2>Sport</h2>\n      <p>\n      <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>\n      <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>\n      <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>\n      </p>\n      <h2>Communication, Marketing, TV</h2>\n      <p>\n      <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>\n      <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>\n      <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>\n      <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>\n      <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>\n      <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>\n      </p>\n\n      <h2>Design</h2>\n      <p>\n      Touchline </b><br>\n      (<a href=\"http://www.touchline.com\" target=\"blank\">www.touchline.com</a>)\n      </p>\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 5,
    subIndex: 0,
    startIndex: 0,
    original: "pg6.jpg",
    zoom: null,
    content: "\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n        <img id=\"6-img\" class=\"halfScale 6-text-1 6-text\" style=\"top:343px;left:480px\" src=\"/113/en/static/_content/6-img.png\">\n        <img id=\"6-title\" class=\"halfScale 6-text-1 6-text\" style=\"top:720px;left:159px\" src=\"/113/en/static/_content/6-title.png\">\n\n        <img id=\"6-text-1\" class=\"halfScale 6-text-1 6-text\" style=\"top:341px;left:784px\" src=\"/113/en/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale 6-text-2 6-text\" style=\"top:338px;left:201px; opacity:0;\" src=\"/113/en/static/_content/6-text-2.png\">\n        <img id=\"6-text-3\" class=\"halfScale 6-text-3 6-text\" style=\"top:338px;left:201px; opacity:0;\" src=\"/113/en/static/_content/6-text-3.png\">\n\n        <img id=\"6-cta-1\" class=\"halfScale pointer 6-btn\" style=\"top:819px;left:783px\" onclick=\"toggleText6('6-text-1', '6-cta-1');\" src=\"/113/en/static/_content/6-cta-1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer 6-btn\" style=\"top:819px;left:965px;opacity:0\" onclick=\"toggleText6('6-text-2', '6-cta-2');\" src=\"/113/en/static/_content/6-cta-2.png\">\n        <img id=\"6-cta-3\" class=\"halfScale pointer 6-btn\" style=\"top:819px;left:1150px;opacity:0\" onclick=\"toggleText6('6-text-3', '6-cta-3');\" src=\"/113/en/static/_content/6-cta-3.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:938px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/6-arrow.png\">\n      ",
    script: "\n      function onPageEnter(){\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(idOf(\"6-img\"), 0.5,{opacity:0}, {opacity:1},0.5)\n            .fromTo(idOf(\"6-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(idOf(\"6-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},\"+=0.3\")\n      }\n\n      function toggleText6(text, btn){\n        console.log(idOf(btn))\n        console.log(cOf(text))\n        TweenMax.to(cOf(\"6-btn\"), 0.1, {opacity:0});\n        TweenMax.to(idOf(btn), 0.1, {opacity:1});\n        TweenMax.to(cOf(\"6-text\"), 0.1, {opacity:0});\n        TweenMax.to(cOf(text), 0.1, {opacity:1});\n      }\n\n      function onPageLeave(){\n        toggleText6('6-text-1', '6-cta-1');\n        pg6Anim.stop();\n        removeContentLinks()\n      }\n      ",
    searchText: "FORE WORD  Dear Fencing Family, The 2020 season is moving forward on the Road to Tokyo where, for the first time in history, 12 senior fencing events will take place at next Summer Olympic Games. Federations, fencers and teams are working hard to make it a excellent year with an exciting series of important fencing activities.  THE CURTAIN RISES ON OLYMPIC SEASON  Our competition season started in September with a series of satellite events followed up by our World Cup events. This month the first of our nine Grand Prix events will take place in  PAGE 1  PAGE 2  PAGE 3  W W W.FIE .ORG",
    mobileHtml: "\n          <h2>The curtain rises on Olympic season</h2>\n          <img src=\"/113/en/static/_mobile/6-img.jpg\">\n          <p><b>Dear Fencing Family,</b></p>\n          <p>The 2020 season is moving forward on the Road to Tokyo where, for the first time in history, 12 senior fencing events will take place at next Summer Olympic Games. Federations, fencers and teams are working hard to make it a excellent year with an exciting series of important fencing activities.</p>\n          <p>Our competition season started in September with a series of satellite events followed up by our World Cup events. This month the first of our nine Grand Prix events will take place in Montreal, Doha and Turin, highlighting the importance of the Olympic qualification period which runs until April. </p>\n          <p>Meanwhile in Tokyo work continues in Tokyo in preparation for the Olympic Games. In December, we worked with our Tokyo organising team to hold the official Olympic Test Event for fencing, which took place in the Makuhari Messe venue featuring the Prince Takamado Trophy Men\u2019s Foil World Cup. </p>\n          <p>At our Annual Congress in Lausanne in November, we were honoured to welcome IOC President Thomas Bach whom the Congress awarded the 2019 Chevalier Feyerick Challenge trophy. We officially approved four new nations as FIE members, bringing our total to 157. The organisation of the 2021 Senior World Championships was granted to Egypt, several countries are now official candidates in the bidding process for 2022 Junior and Cadet (United Arab Emirates), Senior (Hong Kong, Japan and Korea) and Veteran (Bulgaria) World Championships. </p>\n          <p>Numerous decisions were made at the Congress, including giving World or Olympic champions the right to have their names and countries printed on their jackets in red or gold, respectively. It was also decided that beginning with the 2020-2024 quadrennium, all FIE commissions must have a minimum of 30 percent women representation. The 2019 Fair Play trophy was given awarded to the Hungarian men\u2019s sabre team and Bolade Apithy (FRA). Top-ranked junior and senior individuals and teams in each weapon were awarded medals, along with a Nations Grand Prix given to Russia for seniors and Italy for juniors. The closing gala dinner was held at the renowned Olympic Museum in Lausanne, attended by Mr.Bach and other guests along with the members of the International Fencing Family.</p>\n          <p>As the excitement builds for this very important season, the FIE continues to grow fencing worldwide through a wide range of development and educational programs as well as broadened event coverage on social media and broadcast television. We expect that fencing will be presented to more people in 2020 than any year in history. Thank you for being part of the world fencing family and sharing your skills and talents. Each of us can make a difference in achieving success. I wish you all a prosperous and successful New Year and that I am sure that you may achieve your fencing dreams. </p>\n          <br>\n          <p>Alisher Usmanov</p>\n          <p><strong>FIE President</strong></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 6,
    subIndex: 0,
    startIndex: 0,
    original: "pg7.jpg",
    zoom: null,
    content: "\n        \n        <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"top:962px;left:769px;width:719px; height:54px;\"></div>\n        </a>\n        \n        ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg7.jpg\">\n      </a>\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 7,
    subIndex: 0,
    startIndex: 0,
    original: "pg8.jpg",
    zoom: null,
    content: "\n      <img class=\"halfScale 8-title\" style=\"top:110px;left:668px\" src=\"/113/en/static/_content/8-title.png\">\n\n      <img class=\"halfScale 8-line\" style=\"top:290px;left:668px\" src=\"/113/en/static/_content/8-line.png\">\n\n      <img class=\"halfScale 8-sub\" style=\"top:290px;left:711px\" src=\"/113/en/static/_content/8-sub.png\">\n\n      <img class=\"halfScale pointer 8-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax()\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  TALLINN WOMEN’S EPEE WORLD CUP TALLINN, ESTONIA NOVEMBER 1-3, 2019",
    mobileHtml: "\n        <h2>Tallinn women's epee World Cup</h2>\n        <img src=\"/113/en/static/_mobile/pg8.jpg\">\n        <p><b>Tallinn, Estonia<br>\n        November 1-3, 2019<br></b></p>\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 8,
    subIndex: 0,
    startIndex: 0,
    original: "pg9.jpg",
    zoom: null,
    content: "\n      <img class=\"halfScale pointer 9-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/9-arrow.png\"> \n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n      </a>\n      ",
    script: "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax()\n          pg9Anim\n            .fromTo(cOf(\"9-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop()\n        }\n      ",
    searchText: "TALLINN WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 2 OF 3  In the first FIE senior world cup of the 2019-2020 international fencing competition season, Romania’s Ana Maria Popescu took the gold medal in individual women’s epee at Estonia’s 50th annual “Glaive de Tallinn”. Poland also took the women’s epee gold medal in the team competition, which took place at the Kalev Sports Hall and drew 30 teams and 279 athletes from around the world. With the  2020 Olympic Games taking place next July, the qualification phase now underway for the “Road to Tokyo” gives heightened excitement to this and upcoming FIE world cups and Grand Prix events.",
    mobileHtml: "\n          <p>In the first FIE senior world cup of the 2019-2020 international fencing competition season, Romania\u2019s Ana Maria Popescu took the gold medal in individual women\u2019s epee at Estonia\u2019s 50th annual \u201CGlaive de Tallinn\u201D.</p>\n          <p>Poland also took the women\u2019s epee gold medal in the team competition, which took place at the Kalev Sports Hall and drew 30 teams and 279 athletes from around the world. With the 2020 Olympic Games taking place next July, the qualification phase now underway for the \u201CRoad to Tokyo\u201D gives heightened excitement to this and upcoming FIE world cups and Grand Prix events. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 9,
    subIndex: 0,
    startIndex: 0,
    original: "pg10.jpg",
    zoom: null,
    content: "\n        \n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n\n        <img class=\"halfScale pointer 10-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/10-arrow.png\"> \n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax()\n          pg10Anim\n            .fromTo(cOf(\"10-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop()\n        }\n      ",
    searchText: "Final ranking for individual women’s epee at the Tallinn World Cup included Ana Maria Popescu (ROU, gold), Violetta Kolobova (RUS, silver), Yiwen Sun (CHN, bronze), Mingye Zhu (CHN, bronze), Man Wai Vivian Kong (HKG), Leonora Mackinnon (CAN), Josephine Jacques Andre Coquin (FRA) and Nicol Foietta (ITA).  TALLINN WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 3 OF 3  Top-eight results for team women’s epee included Poland (gold), Russia (silver), USA (bronze), China, Estonia, Italy, Germany and Ukraine. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In the final round of individual women’s epee, Popescu defeated Russia’s Violetta Kolobova, 15-13. In the semi-final round, Kolobova beat China’s Mingye Zhu, 15-8, while Popescu narrowly overcame China’s Yiwen Sun, 15-14. The gold medal in women’s team epee was decided by a single touch, with Poland winning against Russia, 45-44. Russia overtook USA in the semi-final round, 45-29, and Poland beat China, 39-28. USA took the bronze over China, 43-35.  W W W.FIE .ORG",
    mobileHtml: "\n          <p>In the final round of individual women\u2019s epee, Popescu defeated Russia\u2019s Violetta Kolobova, 15-13. In the semi-final round, Kolobova beat China\u2019s Mingye Zhu, 15-8, while Popescu narrowly overcame China\u2019s Yiwen Sun, 15-14.</p>\n          <p>The gold medal in women\u2019s team epee was decided by a single touch, with Poland winning against Russia, 45-44. Russia overtook USA in the semi-final round, 45-29, and Poland beat China, 39-28. USA took the bronze over China, 43-35.</p>\n          <p><b>Final ranking for individual women\u2019s epee at the Tallinn World Cup included:</b></p>\n          <p>Ana Maria Popescu (ROU, gold)</p>\n          <p>Violetta Kolobova (RUS, silver)</p>\n          <p>Yiwen Sun (CHN, bronze)</p>\n          <p>Mingye Zhu (CHN, bronze)</p>\n          <p>Man Wai Vivian Kong (HKG)</p>\n          <p>Leonora Mackinnon (CAN)</p>\n          <p>Josephine Jacques Andre Coquin (FRA)</p>\n          <p>Nicol Foietta (ITA)</p>\n          <p><b>Top-eight results for team women\u2019s epee included:</b></p>\n          <p>Poland (gold)</p>\n          <p>Russia (silver)</p>\n          <p>USA (bronze)</p>\n          <p>China, Estonia, Italy, Germany and Ukraine.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 10,
    subIndex: 0,
    startIndex: 0,
    original: "pg11.jpg",
    zoom: null,
    content: "\n      <img class=\"halfScale 11-title\" style=\"top:140px;left:84px\" src=\"/113/en/static/_content/11-title.png\">\n\n      <img class=\"halfScale 11-line\" style=\"top:325px;left:84px\" src=\"/113/en/static/_content/11-line.png\">\n\n      <img class=\"halfScale 11-sub\" style=\"top:324px;left:128px\" src=\"/113/en/static/_content/11-sub.png\">\n\n      <img class=\"halfScale pointer 11-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/11-arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax()\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"11-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  BONN MEN’S FOIL WORLD CUP BONN, GERMANY NOVEMBER 8-10, 2019",
    mobileHtml: "\n          <h2>Bonn men's foil World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg11.jpg\" >\n          <p><strong>Bonn, Germany<br>\n          November 8-10, 2019</strong></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 11,
    subIndex: 0,
    startIndex: 0,
    original: "pg12.jpg",
    zoom: null,
    content: "\n        \n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        \n        \n        <img class=\"halfScale pointer 12-arrow\" style=\"top:845px;left:1406px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/12-arrow.png\"> \n        \n        ",
    script: "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax()\n          pg12Anim\n            .fromTo(cOf(\"12-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop()\n        }\n      ",
    searchText: "BONN MEN'S FOIL FENCING WORLD CUP BONN, GERMANY 2 OF 3  France’s Julien Mertine took the individual gold medal at the 2019 Bonn Men’s Foil World Cup, the 48th annual “Lowe von Bonn”, with USA winning gold in the team event. Taking place at Bonn’s Hardtberghalle, the competition drew 261 international foilists and teams from 26 countries. In the final round of individual men’s foil, Mertine defeated USA’s Gerek Meinhardt, 159. Both fencers overcame world champions in the semi-finals, with Meinhardt beating Italy’s Alessio Foconi, 15-12, and Mertine winning against Italy’s Andrea Cassara, 15-10. Notably,  Meinhardt advanced to the semi-finals against Italian Olympic champion Daniele Garozzo in the round of eight, 15-9, while Mertine beat Germany Olympic champion Benjamin Kleibrink, 15-3. In the men’s team foil final, USA beat Korea for the gold medal, 45-31. Korea defeated Italy,",
    mobileHtml: "\n          <p>France\u2019s Julien Mertine took the individual gold medal at the 2019 Bonn Men\u2019s Foil World Cup, the 48th annual \u201CLowe von Bonn\u201D, with USA winning gold in the team event.</p>\n          <p>Taking place at Bonn\u2019s Hardtberghalle, the competition drew 261 international foilists and teams from 26 countries. </p>\n          <p>In the final round of individual men\u2019s foil, Mertine defeated USA\u2019s Gerek Meinhardt, 15-9. Both fencers overcame world champions in the semi-finals, with Meinhardt beating Italy\u2019s Alessio Foconi, 15-12, and Mertine winning against Italy\u2019s Andrea Cassara, 15-10. Notably, Meinhardt advanced to the semi-finals against Italian Olympic champion Daniele Garozzo in the round of eight, 15-9, while Mertine beat Germany Olympic champion Benjamin Kleibrink, 15-3. </p>\n          <p>In the men\u2019s team foil final, USA beat Korea for the gold medal, 45-31. Korea defeated Italy, 45-37, in the semi-final and USA won against Russia, 45-42. Russia took the bronze medal against Italy, 45-40.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 12,
    subIndex: 0,
    startIndex: 0,
    original: "pg13.jpg",
    zoom: null,
    content: "\n        \n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 13-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/13-arrow.png\"> \n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax()\n          pg13Anim\n            .fromTo(cOf(\"13-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop()\n        }\n      ",
    searchText: "BONN MEN'S FOIL FENCING WORLD CUP BONN, GERMANY 3 OF 3  45-37, in the semi-final and USA won against Russia, 45-42. Russia took the bronze medal against Italy, 45-40. Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In men’s team foil, final ranking included USA (gold), Korea (silver), Russia (bronze), Italy, France, Hong Kong, Japan and Germany. ■  Final ranking in the men’s individual foil event included Julien Mertine (FRA, gold), Gerek Meinhardt (USA, silver), Andrea Cassara (ITA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Kyosuke Matsuyama (JPN), Benjamin Kleibrink (GER) and Carlos Llavador (ESP).  W W W.FIE .ORG",
    mobileHtml: "\n          <p><b>Final ranking in the men\u2019s individual foil event included: </b></p>\n          <p> Julien Mertine (FRA, gold)</p>\n          <p>Gerek Meinhardt (USA, silver) </p>\n          <p>Andrea Cassara (ITA, bronze)</p>\n          <p>Alessio Foconi (ITA, bronze) </p>\n          <p>Daniele Garozzo (ITA) </p>\n          <p>Kyosuke Matsuyama (JPN) </p>\n          <p>Benjamin Kleibrink (GER) </p>\n          <p>Carlos Llavador (ESP) </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 13,
    subIndex: 0,
    startIndex: 0,
    original: "pg14.jpg",
    zoom: null,
    content: "\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('/113/en/static/_content/11-vid.m4v')\" style=\"bottom:460px;left:1146px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <a href=\"http://www.allstar.de\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg14.jpg\">\n      </a>\n      \n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 14,
    subIndex: 0,
    startIndex: 0,
    original: "pg15.jpg",
    zoom: null,
    content: "\n        \n        <img class=\"halfScale 15-title\" style=\"top:140px;left:84px\" src=\"/113/en/static/_content/15-title.png\">\n\n        <img class=\"halfScale 15-line\" style=\"top:325px;left:84px\" src=\"/113/en/static/_content/15-line.png\">\n\n        <img class=\"halfScale 15-sub\" style=\"top:324px;left:126px\" src=\"/113/en/static/_content/15-sub.png\">\n\n        <img class=\"halfScale pointer 15-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/15-arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax()\n          pg15Anim.fromTo(cOf(\"15-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"15-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"15-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"15-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  CAIRO MEN’S SABRE WORLD CUP CAIRO, EGYPT NOVEMBER 15-17, 2019",
    mobileHtml: "\n          <h2>Cairo men's sabre World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg15.jpg\" >\n          <p><strong>Cairo, Egypt<br>\n          November 15-17, 2019</strong><p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 15,
    subIndex: 0,
    startIndex: 0,
    original: "pg16.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 16-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/16-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax()\n          pg16Anim\n            .fromTo(cOf(\"16-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop()\n        }",
    searchText: "CAIRO MEN'S SABRE WORLD CUP CAIRO, EGYPT 2 OF 2  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  France’s Vincent Anstett won the men’s individual gold medal at the 2019 Cairo Men’s Sabre World Cup, and Korea took the gold in the men’s team event.  event included Vincent Anstett (FRA, gold), Luigi Samele (ITA, silver), Fares Ferjani (TUN, bronze), Junghwan Kim (KOR, bronze), Bolade Apithy (FRA), Mohamed Amer (EGY), Gabriele Foschini (ITA) and Riccardo Nuccio (ITA).  The event took place at the Cairo Stadium Indoor Halls Complex with 194 international men’s sabre fencers and teams from 26 countries.  In men’s team sabre, final ranking included Korea (gold), Hungary (silver), Italy (bronze), Russia, Germany, Iran, China and France. ■  Anstett took on Italy’s Luigi Samele in the goldmedal match of the men’s individual sabre event, winning by a single point, 15-14. Samele overcame Tunisia’s Fares Ferjani in the semifinal round, 15-8, and Anstett beat Korea’s world champion Junghwan Kim in another close bout, 15-14. Notably, world champions Andras Szatmari (HUN) and Veniamin Reshetnikov (RUS) finished in the top 16. In men’s team sabre, Korea faced Hungary in the final round, taking gold with a 45-41 score. Hungary beat Italy in the semi-final round, 45-37, and Korea defeated Russia, 45-39. The bronze medal went to Italy over Russia, 45-31. Final ranking in the men’s individual sabre  W W W.FIE .ORG",
    mobileHtml: "\n          <p>France\u2019s Vincent Anstett won the men\u2019s individual gold medal at the 2019 Cairo Men\u2019s Sabre World Cup, and Korea took the gold in the men\u2019s team event.</p>\n          <p>The event took place at the Cairo Stadium Indoor Halls Complex with 194 international men\u2019s sabre fencers and teams from 26 countries.</p>\n          <p>In men\u2019s team sabre, Korea faced Hungary in the final round, taking gold with a 45-41 score. Hungary beat Italy in the semi-final round, 45-37, and Korea defeated Russia, 45-39. The bronze medal went to Italy over Russia, 45-31.</p>\n          <p><b>Final ranking in the men\u2019s individual sabre event included: </b></p>\n          <p>Vincent Anstett (FRA, gold) </p>\n          <p>Luigi Samele (ITA, silver) </p>\n          <p>Fares Ferjani (TUN, bronze) </p>\n          <p>Junghwan Kim (KOR, bronze) </p>\n          <p>Bolade Apithy (FRA) </p>\n          <p>Mohamed Amer (EGY) </p>\n          <p>Abriele Foschini (ITA) </p>\n          <p>Riccardo Nuccio (ITA) </p>\n          <p><b>In men\u2019s team sabre, final ranking included:</b></p>\n          <p>Korea (gold) </p>\n          <p>Hungary (silver) </p>\n          <p>Italy (bronze) </p>\n          <p>Russia, Germany, Iran, China and France. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 16,
    subIndex: 0,
    startIndex: 0,
    original: "pg17.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 17-title\" style=\"top:141px;left:84px\" src=\"/113/en/static/_content/17-title.png\">\n\n        <img class=\"halfScale 17-line\" style=\"top:245px;left:84px\" src=\"/113/en/static/_content/17-line.png\">\n\n        <img class=\"halfScale 17-sub\" style=\"top:245px;left:127px\" src=\"/113/en/static/_content/17-sub.png\">\n\n        <img class=\"halfScale pointer 17-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/17-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax()\n          pg17Anim.fromTo(cOf(\"17-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"17-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"17-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"17-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  BERNE MEN’S EPEE WORLD CUP BERNE, SWITZERLAND NOVEMBER 22-24, 2019",
    mobileHtml: "\n          <h2>Berne men's epee World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg17.jpg\" >\n          <p><strong>Berne, Switzerland<br>\n          November 22-24, 2019</strong><p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 17,
    subIndex: 0,
    startIndex: 0,
    original: "pg18.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 18-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/16-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n      ",
    script: "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax()\n          pg18Anim\n            .fromTo(cOf(\"18-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop()\n        }\n      ",
    searchText: "BERNE MEN'S EPEE WORLD CUP BERNE, SWITZERLAND 2 OF 2  Ukraine’s Igor Reizlin took the gold medal at the “Tissot Grand Prix de Berne” Men’s Epee World Cup, with France winning the team gold medal men’s team event. Taking place at Berne’s Haus des Sports, the event drew 324 international men’s epee fencers and teams from 31 countries. Reizlin faced Russia’s Vadim Anokhin in the final round of the men’s individual epee competition, winning closely with a 11-10 score to take  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  the gold medal. Anokhin defeated Ukraine’s Roman Svichkar in the semi-final round, 15-8, and Reizlin beat France’s Alexandre Bardenet, 15-10. Notably, French world champion Yannick Borel lost to Reizlin in the quarter-finals, 1512, while Olympic champions Ruben Limardo Gascon (VEN) and Sangyoung Park (KOR) were beaten in the round of 16. Team France had a close win in the final round of men’s team epee, overcoming Team Italy 45-44. In the semi-final, Italy beat Ukraine, 3231, and France beat Japan, 45-40. The bronze medal went to Ukraine over Japan, also by a single touch, 32-31. Final individual rankings in the Berne Men’s Epee World Cup included Igor Reizlin (UKR, gold), Vadim Anokhin (RUS, silver), Alexandre Bardenet (FRA, bronze), Roman Svichkar (UKR, bronze), Bogdan Nikishin (UKR), Yannick Borel (FRA), Houssam Elkord (MAR) and Tibor Andrasfi (HUN). Team rankings included France (gold), Italy (silver), Ukraine (bronze), Japan, Korea, China, Switzerland and Poland. ■  W W W.FIE .ORG",
    mobileHtml: "\n          <p>Ukraine\u2019s Igor Reizlin took the gold medal at the \u201CTissot Grand Prix de Berne\u201D Men\u2019s Epee World Cup, with France winning the team gold medal men\u2019s team event. </p>\n          <p>Taking place at Berne\u2019s Haus des Sports, the event drew 324 international men\u2019s epee fencers and teams from 31 countries. </p>\n          <p>Reizlin faced Russia\u2019s Vadim Anokhin in the final round of the men\u2019s individual epee competition, winning closely with a 11-10 score to take the gold medal. Anokhin defeated Ukraine\u2019s Roman Svichkar in the semi-final round, 15-8, and Reizlin beat France\u2019s Alexandre Bardenet, 15-10. Notably, French world champion Yannick Borel lost to Reizlin in the quarter-finals, 15-12, while Olympic champions Ruben Limardo Gascon (VEN) and Sangyoung Park (KOR) were beaten in the round of 16. </p>\n          <p>Team France had a close win in the final round of men\u2019s team epee, overcoming Team Italy 45-44. In the semi-final, Italy beat Ukraine, 32-31, and France beat Japan, 45-40. The bronze medal went to Ukraine over Japan, also by a single touch, 32-31. </p>\n          <p><b>Final individual rankings in the Berne Men\u2019s Epee World Cup included: </b></p>\n          <p>Igor Reizlin (UKR, gold) </p>\n          <p>Vadim Anokhin (RUS, silver) </p>\n          <p>Alexandre Bardenet (FRA, bronze) </p>\n          <p>Roman Svichkar (UKR, bronze) </p>\n          <p>Bogdan Nikishin (UKR)</p>\n          <p>Yannick Borel (FRA) </p>\n          <p>Houssam Elkord (MAR) </p>\n          <p>Tibor Andrasfi (HUN) </p>\n          <p><b>Team rankings included </b></p>\n          <p>France (gold) </p>\n          <p>Italy (silver) </p>\n          <p>Ukraine (bronze) </p>\n          <p>Japan, Korea, China, Switzerland and Poland. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 18,
    subIndex: 0,
    startIndex: 0,
    original: "pg19.jpg",
    zoom: null,
    content: "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:331px;right:1053px;width:256px; height:30px;\"></div>\n          </a>\n        ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <img src=\"/113/en/static/_mobile/pg19.jpg\">\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 19,
    subIndex: 0,
    startIndex: 0,
    original: "pg20.jpg",
    zoom: null,
    content: "\n          <a href=\"http://www.fencingsets.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:864px;left:283px;width:228px; height:30px;\"></div>\n          </a>\n\n          <a href=\"mailto:755037302@qq.com\">\n            <div class=\"contentLinkNone\" style=\"top:894px;left:283px;width:215px; height:30px;\"></div>\n          </a>\n\n          <a href=\"mailto:1135864400@qq.com\">\n            <div class=\"contentLinkNone\" style=\"top:894px;left:500px;width:173px; height:30px;\"></div>\n          </a>\n        ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <img src=\"/113/en/static/_mobile/pg20.jpg\">\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 20,
    subIndex: 0,
    startIndex: 0,
    original: "pg21.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 21-title\" style=\"top:264px;left:82px\" src=\"/113/en/static/_content/21-title.png\">\n\n        <img class=\"halfScale 21-line\" style=\"top:550px;left:84px\" src=\"/113/en/static/_content/21-line.png\">\n\n        <img class=\"halfScale 21-sub\" style=\"top:544px;left:126px\" src=\"/113/en/static/_content/21-sub.png\">\n\n       <img class=\"halfScale pointer 21-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/21-arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax()\n          pg21Anim.fromTo(cOf(\"21-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"21-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"21-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"21-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  ORLÉANS WOMEN’S SABRE WORLD CUP ORLÉANS, FRANCE NOVEMBER 22-24, 2019",
    mobileHtml: "\n          <h2>Orl\xE9ans women's sabre World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg21.jpg\" >\n          <p><strong>Orl\xE9ans, France<br>\n          November 22-24, 2019</strong><p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 21,
    subIndex: 0,
    startIndex: 0,
    original: "pg22.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale pointer 22-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/22-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax()\n          pg22Anim.fromTo(cOf(\"22-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop()\n        }\n      ",
    searchText: "ORLÉANS WOMEN'S SABRE WORLD CUP ORLÉANS, FRANCE 2 OF 3  France’s Manon Brunet won the individual gold medal at the Orleans “Trophée Orcom” Women’s Sabre World Cup, with Russia taking the gold in the team competition. Finals took place at the City’s Zenith d’Orléans, with 212 international women’s sabre fencers participating along with teams from 26 countries. Brunet fenced Russia’s Olga Nikitina in the final match, winning with a 15-12 score. Nikitina beat  China’s Yaqi Shao in the semi-final, 15-11, while Brunet narrowly defeated four-time Ukrainian world champion Olga Kharlan, 15-14. Brunet beat Korean Olympic champion Jiyeon Kim in the quarter-final round, 15-4, while Kharlan overtook Russian world champion Sofia Pozdniakova, 15-10. Of note, Russian Olympic champion Yana Egorian was eliminated by France’s Charlotte Lembach in the table of 16, 15-13, after beating her teammate and twotime Russian world champion, Sofya Velikaya, 15-10, in the round of 32.",
    mobileHtml: "\n          <p>France\u2019s Manon Brunet won the individual gold medal at the Orleans \u201CTroph\xE9e Orcom\u201D Women\u2019s Sabre World Cup, with Russia taking the gold in the team competition. </p>\n          <p>Finals took place at the City\u2019s Zenith d\u2019Orl\xE9ans, with 212 international women\u2019s sabre fencers participating along with teams from 26 countries. </p>\n          <p>Brunet fenced Russia\u2019s Olga Nikitina in the final match, winning with a 15-12 score. Nikitina beat China\u2019s Yaqi Shao in the semi-final, 15-11, while Brunet narrowly defeated four-time Ukrainian world champion Olga Kharlan, 15-14. Brunet beat Korean Olympic champion Jiyeon Kim in the quarter-final round, 15-4, while Kharlan overtook Russian world champion Sofia Pozdniakova, 15-10. Of note, Russian Olympic champion Yana Egorian was eliminated by France\u2019s Charlotte Lembach in the table of 16, 15-13, after beating her teammate and two-time Russian world champion, Sofya Velikaya, 15-10, in the round of 32. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 22,
    subIndex: 0,
    startIndex: 0,
    original: "pg23.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 23-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/23-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax()\n          pg23Anim\n            .fromTo(cOf(\"23-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop()\n        }\n      ",
    searchText: "ORLÉANS WOMEN'S SABRE WORLD CUP ORLÉANS, FRANCE 3 OF 3  In the women’s team sabre competition, Russia took the gold medal against Korea, 45-41. Korea beat Ukraine in the semi-final round, 45-43, while Russia beat Hungary, 4526. The bronze medal went to Ukraine over Hungary, 45-36. Final individual rankings in the Orleans Women’s Sabre World Cup included Manon  Brunet (FRA, gold), Olga Nikitina (RUS, silver), Olga Kharlan (UKR, bronze), Yaqi Shao (CHN, bronze), Jiyeon Kim (KOR), Sofia Pozdniakova (RUS), Bianca Pascu (ROU) and Charlotte Lembach (FRA). Team rankings included Russia (gold), Korea (silver), Ukraine (bronze), Hungary, France, Italy, China and Spain. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
    mobileHtml: "\n          <p>In the women\u2019s team sabre competition, Russia took the gold medal against Korea, \n          45-41. Korea beat Ukraine in the semi-final round, 45-43, while Russia beat Hungary, 45-26. The bronze medal went to Ukraine over Hungary, 45-36.</p>\n          <p><b>Final individual rankings in the Orleans Women\u2019s Sabre World Cup included: </b></p>\n          <p>Manon Brunet (FRA, gold) </p>\n          <p>Olga Nikitina (RUS, silver) </p>\n          <p>Olga Kharlan (UKR, bronze) </p>\n          <p>Yaqi Shao (CHN, bronze) </p>\n          <p>Jiyeon Kim (KOR) </p>\n          <p>Sofia Pozdniakova (RUS) </p>\n          <p>Bianca Pascu (ROU) </p>\n          <p>Charlotte Lembach (FRA) </p>\n          <p><b>Team rankings included</b></p>\n          <p>Russia (gold)</p>\n          <p>Korea (silver) </p>\n          <p>Ukraine (bronze) </p>\n          <p>Hungary, France, Italy, China and Spain. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 23,
    subIndex: 0,
    startIndex: 0,
    original: "pg24.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 24-title\" style=\"top:123px;left:664px\" src=\"/113/en/static/_content/24-title.png\">\n\n        <img class=\"halfScale 24-line\" style=\"top:302px;left:667px\" src=\"/113/en/static/_content/24-line.png\">\n\n        <img class=\"halfScale 24-sub\" style=\"top:303px;left:710px\" src=\"/113/en/static/_content/24-sub.png\">\n\n       <img class=\"halfScale pointer 24-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/24-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax()\n          pg24Anim.fromTo(cOf(\"24-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"24-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"24-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"24-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  CAIRO WOMEN’S FOIL WORLD CUP CAIRO, EGYPT NOVEMBER 22-24, 2019",
    mobileHtml: "\n          <h2>Cairo women's foil World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg24.jpg\" >\n          <p><strong>Cairo, Egypt<br>\n          November 22-24, 2019</strong><p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 24,
    subIndex: 0,
    startIndex: 0,
    original: "pg25.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 25-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/25-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax()\n          pg25Anim\n            .fromTo(cOf(\"25-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop()\n        }\n      ",
    searchText: "CAIRO WOMEN'S FOIL WORLD CUP CAIRO, EGYPT 2 OF 3  Italian two-time world champion Arianna Errigo won individual gold at the Cairo Women’s Foil World Cup, and Italy took the team gold medal. The event took place at the Cairo Stadium Indoor Halls Complex, with 170 international women’s foilists competing along with teams from 17 countries. In the gold-medal final, Errigo faced China’s Yue Shi, winning with a 15-6 score. Shi  overtook Italian Olympic and world champion Elisa Di Francisca in the semi-final round, 1511, and Errigo closely defeated France’s Ysaora Thibus, 15-14. Of note, Thibus beat Russian Olympic and three-time world champion Inna Deriglazova in the quarter-finals, 15-13.",
    mobileHtml: "\n          <p>Italian two-time world champion Arianna Errigo won individual gold at the Cairo Women\u2019s Foil World Cup, and Italy took the team gold medal </p>\n          <p>The event took place at the Cairo Stadium Indoor Halls Complex, with 170 international women\u2019s foilists competing along with teams from 17 countries. </p>\n          <p>In the gold-medal final, Errigo faced China\u2019s Yue Shi, winning with a 15-6 score. Shi overtook Italian Olympic and world champion Elisa Di Francisca in the semi-final round, 15-11, and Errigo closely defeated France\u2019s Ysaora Thibus, 15-14. Of note, Thibus beat Russian Olympic and three-time world champion Inna Deriglazova in the quarter-finals, 15-13. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 25,
    subIndex: 0,
    startIndex: 0,
    original: "pg26.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 26-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/26-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax()\n          pg26Anim\n            .fromTo(cOf(\"26-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop()\n        }\n      ",
    searchText: "(FRA, bronze), Inna Deriglazova (RUS), Lee Kiefer (USA), Rio Azuma (JPN) and Martina Batini (ITA).  CAIRO WOMEN'S FOIL WORLD CUP CAIRO, EGYPT 3 OF 3  Team women’s foil final rankings included Italy (gold), Russia (silver), France (bronze), USA, Canada, Hungary, China and Germany. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Italy defeated Russia in the final round of the women’s team foil event, 42-40. Russia beat USA in the semi-final, 45-34, and Italy overcame France, 45-38. The bronze medal went to France over USA, 45-40. Final rankings for the Cairo Women’s Foil World Cup individual event included Arianna Errigo (ITA, gold), Yue Shi (CHN, silver), Elisa Di Francisca (ITA, bronze), Ysaora Thibus  W W W.FIE .ORG",
    mobileHtml: "\n          <p>Italy defeated Russia in the final round of the women\u2019s team foil event, 42-40. Russia beat USA in the semi-final, 45-34, and Italy overcame France, 45-38. The bronze medal went to France over USA, 45-40. </p>\n          <p><b>Final rankings for the Cairo Women\u2019s Foil World Cup individual event included: </b> </p>\n          <p>Arianna Errigo (ITA, gold) </p>\n          <p>Yue Shi (CHN, silver) </p>\n          <p>Elisa Di Francisca (ITA, bronze) </p>\n          <p>Ysaora Thibus  (FRA, bronze) </p>\n          <p>Inna Deriglazova (RUS) </p>\n          <p>Lee Kiefer (USA) </p>\n          <p>Rio Azuma (JPN) </p>\n          <p>Martina Batini (ITA) </p>\n          <p><b>Team women\u2019s foil final rankings included: </b> </p>\n          <p>Italy (gold) </p>\n          <p> Russia (silver)</p>\n          <p>France (bronze) </p>\n          <p>USA, Canada, Hungary, China and Germany. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 26,
    subIndex: 0,
    startIndex: 0,
    original: "pg27.jpg",
    zoom: null,
    content: "\n        <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:939px;left:250px;width:1080px; height:75px;\"></div>\n          </a>\n          \n          <a href=\"mailto:service@blue-gauntletservice.com\">\n            <div class=\"contentLinkNone\" style=\"top:1028px;left:384px;width:823px; height:49px;\"></div>\n          </a>\n          ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "  \n        <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg27.jpg\">\n        </a>\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 27,
    subIndex: 0,
    startIndex: 0,
    original: "pg28.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 28-title\" style=\"top:131px;left:498px\" src=\"/113/en/static/_content/28-title.png\">\n\n        <img class=\"halfScale 28-line\" style=\"top:289px;left:1018px\" src=\"/113/en/static/_content/28-line.png\">\n\n        <img class=\"halfScale 28-sub\" style=\"top:287px;left:1061px\" src=\"/113/en/static/_content/28-sub.png\">\n\n        <img class=\"halfScale pointer 28-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/28-arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax()\n          pg28Anim.fromTo(cOf(\"28-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"28-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"28-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"28-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  SAINT-MAUR WOMEN’S FOIL SAINT-MAUR, FRANCE WORLD CUP DECEMBER 13-15, 2019",
    mobileHtml: "\n          <h2>Saint-Maur women's foil World Cup </h2>\n          <img src=\"/113/en/static/_mobile/pg28.jpg\" >\n          <p><strong>Saint-Maur, France<br>\n          December 13-15, 2019</strong><p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 28,
    subIndex: 0,
    startIndex: 0,
    original: "pg29.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 29-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/29-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax()\n          pg29Anim\n            .fromTo(cOf(\"29-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop()\n        }\n      ",
    searchText: "SAINT-MAUR WOMEN'S FOIL FENCING WORLD CUP SAINT-MAUR, FRANCE 2 OF 3  Italy’s world champion Alice Volpi won the individual gold medal at the Saint-Maur Women’s Foil World Cup, with Russia taking gold in women’s team foil. The event, which took place at the City’s Sport Centre Pierre Brossolette, featured 205 international women’s foilists and 23 teams. Volpi fenced her teammate, Martina Batini, in the final round, taking the gold medal with a  15-10 score. Batini narrowly defeated Russia’s Olympic and three-time world champion Inna Deriglazova in the semi-final round, 15-14, while Volpi beat USA’s Lee Kiefer, 15-13. Notably, Kiefer overcame Italian two-time world champion Arianna Errigo in the quarter-finals,",
    mobileHtml: "\n          <p>Italy\u2019s world champion Alice Volpi won the individual gold medal at the Saint-Maur Women\u2019s Foil World Cup, with Russia taking gold in women\u2019s team foil. </p>\n          <p>The event, which took place at the City\u2019s Sport Centre Pierre Brossolette, featured 205 international women\u2019s foilists and 23 teams. </p>\n          <p>Volpi fenced her teammate, Martina Batini, in the final round, taking the gold medal with a 15-10 score. Batini narrowly defeated Russia\u2019s Olympic and three-time world champion Inna Deriglazova in the semi-final round, 15-14, while Volpi beat USA\u2019s Lee Kiefer, 15-13. Notably, Kiefer overcame Italian two-time world champion Arianna Errigo in the quarter-finals, 15-11, and Italy\u2019s Olympic and world champion Elisa Di Francisca was eliminated in the round of 16 by Russia\u2019s Adelina Zagidullina, 15-11.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 29,
    subIndex: 0,
    startIndex: 0,
    original: "pg30.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 30-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/30-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax()\n          pg30Anim\n            .fromTo(cOf(\"30-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop()\n        }\n      ",
    searchText: "SAINT-MAUR WOMEN'S FOIL FENCING WORLD CUP SAINT-MAUR, FRANCE 3 OF 3  15-11, and Italy’s Olympic and world champion Elisa Di Francisca was eliminated in the round of 16 by Russia’s Adelina Zagidullina, 15-11. For the women’s team foil gold medal, Russia overcame Italy by a single touch, 42-41. Italy beat Hungary in the semi-final, 45-28, and Russia defeated Japan, 40-21. The bronze medal went to Japan over Hungary, 45-32.  (FRA), Adelina Zagidullina (RUS) and Anita Blaze (FRA). Ranking for women’s team foil included Russia (gold), Italy (silver), Japan (bronze), Hungary, France, USA, China and Poland. ■  Final individual rankings at the Saint-Maur Women’s Foil World Cup included Alice Volpi (ITA, gold), Martina Batini (ITA, silver), Inna Deriglazova (RUS, bronze), Lee Kiefer (USA, bronze), Arianna Errigo (ITA), Ysaora Thibus  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
    mobileHtml: "\n          <p>For the women\u2019s team foil gold medal, Russia overcame Italy by a single touch, 42-41. Italy beat Hungary in the semi-final, 45-28, and Russia defeated Japan, 40-21. The bronze medal went to Japan over Hungary, 45-32. </p>\n          <p><b>Final individual rankings at the Saint-Maur Women\u2019s Foil World Cup included: </b> </p>\n          <p>Alice Volpi (ITA, gold) </p>\n          <p>Martina Batini (ITA, silver) </p>\n          <p>Inna Deriglazova (RUS, bronze) </p>\n          <p>Lee Kiefer (USA, bronze) </p>\n          <p>Arianna Errigo (ITA) </p>\n          <p>Ysaora Thibus (FRA) </p>\n          <p>Adelina Zagidullina (RUS) </p>\n          <p>Anita Blaze (FRA) </p>\n          <p><b>Ranking for women\u2019s team foil included: </b> </p>\n          <p>Russia (gold) </p>\n          <p>Italy (silver) </p>\n          <p>Japan (bronze) </p>\n          <p>Hungary, France, USA, China and Poland. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 30,
    subIndex: 0,
    startIndex: 0,
    original: "pg31.jpg",
    zoom: null,
    content: "\n        <a href=\"http://favero.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:769px;left:1000px;width:165px; height:55px;\"></div>\n          </a>\n          ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"http://favero.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg31.jpg\">\n      </a>\n\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 31,
    subIndex: 0,
    startIndex: 0,
    original: "pg32.jpg",
    zoom: null,
    content: "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1000px;left:816px;width:223px; height:25px;\"></div>\n          </a>\n\n          <a href=\"mailto:jason@jiangfencing.com\">\n            <div class=\"contentLinkNone\" style=\"top:1025px;left:828px;width:239px; height:25px;\"></div>\n          </a>\n          ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg32.jpg\">\n      </a>\n\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 32,
    subIndex: 0,
    startIndex: 0,
    original: "pg33.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 33-title\" style=\"top:238px;left:84px\" src=\"/113/en/static/_content/33-title.png\">\n\n        <img class=\"halfScale 33-line\" style=\"top:479px;left:289px\" src=\"/113/en/static/_content/33-line.png\">\n\n        <img class=\"halfScale 33-sub\" style=\"top:478px;left:332px\" src=\"/113/en/static/_content/33-sub.png\">\n\n       <img class=\"halfScale pointer 33-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/33-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax()\n          pg33Anim.fromTo(cOf(\"33-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"33-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"33-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"33-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  SALT LAKE CITY WOMEN’S SABRE WORLD CUP SALT LAKE CITY, USA DECEMBER 13-15, 2019",
    mobileHtml: "\n          <h2>Salt Lake City women's sabre World Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg33.jpg\" >\n          <p><strong>Salt Lake City, USA<br>\n          December 13-15, 2019</strong></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 33,
    subIndex: 0,
    startIndex: 0,
    original: "pg34.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 34-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/34-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax()\n          pg34Anim\n            .fromTo(cOf(\"34-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop()\n        }\n      ",
    searchText: "WOMEN'S SABRE WORLD CUP IN SALT LAKE CITY SALT LAKE CITY, USA 2 OF 2  Ukraine’s four-time world champion Olga Kharlan scored the individual gold medal at the Absolute Fencing Gear Women’s Sabre World Cup in Salt Lake City, with France taking the gold in the women’s team event. Held at the Salt Palace Convention Center, the competition drew 185 women’s sabre fencers and 25 teams from around the world.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Kharlan faced China’s Jiarui Qian in the final round, winning with a 15-9 score. Qian defeated Korea’s Jiyeon Seo by one point in the semi-final, 15-14, and Kharlan beat France’s Manon Brunet, 15-9. Two-time Russian world champion Sofya Velikaya lost in the round of 16 to France’s Sarah Noutcha, 15-13, while Ukraine’s Alina Komashchuk beat Russian world champion Sofia Pozdniakova, 15-12, and Kharlan defeated USA’s two-time Olympic and world champion Mariel Zagunis, 15-9. In the women’s team sabre event, France overcame Hungary for the gold medal, 45-25. Hungary eliminated Ukraine in the semi-final,  45-42, and France beat USA, 45-31. The bronze medal went to USA over Ukraine, 45-39. Final individual ranking for the Absolute Fencing Gear Women’s Sabre World Cup included Olga Kharlan (UKR, gold), Jiarui Qian (CHN, silver), Manon Brunet (FRA, bronze), Jiyeon Seo (KOR, bronze), Misaki Emura (JPN), Alina Komashchuk (UKR), Anna Limbach (GER) and Sarah Noutcha (FRA). Team ranking included France (gold), Hungary (silver), USA (bronze), Ukraine, Italy, Korea, China and Russia. ■  W W W.FIE .ORG",
    mobileHtml: "\n          <p>Ukraine\u2019s four-time world champion Olga Kharlan scored the individual gold medal at the Absolute Fencing Gear Women\u2019s Sabre World Cup in Salt Lake City, with France taking the gold in the women\u2019s team event.</p>\n          <p>Held at the Salt Palace Convention Center, the competition drew 185 women\u2019s sabre fencers and 25 teams from around the world. </p>\n          <p>Kharlan faced China\u2019s Jiarui Qian in the final round, winning with a 15-9 score. Qian defeated Korea\u2019s Jiyeon Seo by one point in the semi-final, 15-14, and Kharlan beat France\u2019s Manon Brunet, 15-9. Two-time Russian world champion Sofya Velikaya lost in the round of 16 to France\u2019s Sarah Noutcha, 15-13, while Ukraine\u2019s Alina Komashchuk beat Russian world champion Sofia Pozdniakova, 15-12, and Kharlan defeated USA\u2019s two-time Olympic and world champion Mariel Zagunis, 15-9. </p>\n          <p>In the women\u2019s team sabre event, France overcame Hungary for the gold medal, 45-25. Hungary eliminated Ukraine in the semi-final, 45-42, and France beat USA, 45-31. The bronze medal went to USA over Ukraine, 45-39. </p>\n          <p><b>Final individual ranking for the Absolute Fencing Gear Women\u2019s Sabre World Cup included: </b></p>\n          <p>Olga Kharlan (UKR, gold) </p>\n          <p>Jiarui Qian (CHN, silver) </p>\n          <p>Manon Brunet (FRA, bronze) </p>\n          <p>Jiyeon Seo (KOR, bronze) </p>\n          <p>Misaki Emura (JPN) </p>\n          <p>Alina Komashchuk (UKR) </p>\n          <p>Anna Limbach (GER) </p>\n          <p>Sarah Noutcha (FRA) </p>\n          <p><b> </b></p>\n          <p><b>Team ranking included: </b></p>\n          <p>France (gold) </p>\n          <p>Hungary (silver) </p>\n          <p>USA (bronze) </p>\n          <p>Ukraine, Italy, Korea, China and Russia. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 34,
    subIndex: 0,
    startIndex: 0,
    original: "pg35.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 35-title\" style=\"top:164px;left:803px\" src=\"/113/en/static/_content/35-title.png\">\n\n        <img class=\"halfScale 35-line\" style=\"top:523px;left:802px\" src=\"/113/en/static/_content/35-line.png\">\n\n        <img class=\"halfScale 35-sub\" style=\"top:522px;left:844.9px\" src=\"/113/en/static/_content/35-sub.png\">\n\n       <img class=\"halfScale pointer 35-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/35-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax()\n          pg35Anim.fromTo(cOf(\"35-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"35-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"35-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"35-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop()\n        }\n      ",
    searchText: "WORLD CUP  TOKYO MEN’S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN DECEMBER 13-15, 2019",
    mobileHtml: "\n          <h2>Tokyo men's foil World Cup and Olympic test event</h2>\n          <img src=\"/113/en/static/_mobile/pg35.jpg\" >\n          <p><strong>Tokyo, Japan<br>\n          December 13-15, 2019</strong></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 35,
    subIndex: 0,
    startIndex: 0,
    original: "pg36.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 36-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/36-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax()\n          pg36Anim\n            .fromTo(cOf(\"36-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop()\n        }\n      ",
    searchText: "TOKYO MEN'S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN 2 OF 3  Italian world champion Alessio Foconi took the men’s individual foil gold medal at the 2019 H.I.H. Prince Takamado Trophy Men’s Foil World Cup in Tokyo, with France winning men’s team foil. The competition drew 211 men’s foilists and 19 teams from around the world. This World Cup, which was also an official Test Event for fencing, took place in the Makuhari Messe in Chiba City where fencing will be held at the 2020 Olympic Games.  Foconi won the final match of the men’s individual foil event against France’s Maxime Pauty, 15-5. Pauty defeated Russian world champion Alexey Cheremisinov in the semi-final round, 15-10, while Foconi beat teammate and Olympic champion Daniele Garozzo, 15-10. Notably, Foconi overcame another teammate and world champion, Andrea Cassara, in the quarter-finals, 15-8, and Cheremisinov beat French world champion Enzo Lefort, 15-6. Russian world champion",
    mobileHtml: "\n          <p>Italian world champion Alessio Foconi took the men\u2019s individual foil gold medal at the 2019 H.I.H. Prince Takamado Trophy Men\u2019s Foil World Cup in Tokyo, with France winning men\u2019s team foil. </p>\n          <p>The competition drew 211 men\u2019s foilists and 19 teams from around the world. This World Cup, which was also an official Test Event for fencing, took place in the Makuhari Messe in Chiba City where fencing will be held at the 2020 Olympic Games. </p>\n          <p>Foconi won the final match of the men\u2019s individual foil event against France\u2019s Maxime Pauty, 15-5. Pauty defeated Russian world champion Alexey Cheremisinov in the semi-final round, 15-10, while Foconi beat teammate and Olympic champion Daniele Garozzo, 15-10. Notably, Foconi overcame another teammate and world champion, Andrea Cassara, in the quarter-finals, 15-8, and Cheremisinov beat French world champion Enzo Lefort, 15-6. Russian world champion Dmitry Zherebchenko lost in the round of 16 to teammate Cheremisinov, 15-12. </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 36,
    subIndex: 0,
    startIndex: 0,
    original: "pg37.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/red-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/red-facebook.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:705px;left:61px\" src=\"/113/en/static/_content/red-trophy.png\">\n        </a>\n        <a href=\"https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:872px;left:49px\" src=\"/113/en/static/_content/red-yt.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 37-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/37-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>",
    script: "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax()\n          pg37Anim\n            .fromTo(cOf(\"37-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop()\n        }        \n      ",
    searchText: "TOKYO MEN'S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN 3 OF 3  Dmitry Zherebchenko lost in the round of 16 to teammate Cheremisinov, 15-12. In men’s team foil, France scored the gold medal against USA, 45-39. The USA won against Russia in the semi-final, 45-34, and France overcame Italy, 45-27. The bronze medal went to Italy over Russia, 45-38. Final rankings for men’s individual foil included Alessio Foconi (ITA, gold), Maxime Pauty (FRA, silver), Alexey Cheremisinov (RUS, bronze), Daniele Garozzo (ITA, bronze), Enzo Lefort (FRA), Alexander Massialas (USA), Andrea Cassara (ITA) and Nick Itkin (USA). Ranking for men’s team foil included France (gold), USA (silver), Italy (bronze), Russia, Korea, Hong Kong, China and Japan. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
    mobileHtml: "\n          <p>In men\u2019s team foil, France scored the gold medal against USA, 45-39. The USA won against Russia in the semi-final, 45-34, and France overcame Italy, 45-27. The bronze medal went to Italy over Russia, 45-38.</p>\n          <p><b>Final rankings for men\u2019s individual foil included</b></p>\n          <p>Alessio Foconi (ITA, gold)</p>\n          <p>Maxime Pauty (FRA, silver)</p>\n          <p>Alexey Cheremisinov (RUS, bronze)</p>\n          <p>Daniele Garozzo (ITA, bronze)</p>\n          <p>Enzo Lefort (FRA)</p>\n          <p>Alexander Massialas (USA)</p>\n          <p>Andrea Cassara (ITA)</p>\n          <p>Nick Itkin (USA)</p>\n          <p><b>Ranking for men\u2019s team foil included</b></p>\n          <p>France (gold)</p>\n          <p>USA (silver)</p>\n          <p>Italy (bronze)</p>\n          <p>Russia, Korea, Hong Kong, China and Japan.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 37,
    subIndex: 0,
    startIndex: 0,
    original: "pg38.jpg",
    zoom: null,
    content: "\n        <div class=\"contentLink\" style=\"bottom:193px;right:633px;width:180px; height:30px;\">\n          <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:844px;width:30px; height:30px;\">\n          <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:813px;width:30px; height:30px;\">\n          <a href=\"http://www.instagram.com/Uhlmann.Fencing\" target=\"_blank\"></a>\n        </div>\n    ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg38.jpg\">\n      </a>\n\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 38,
    subIndex: 0,
    startIndex: 0,
    original: "pg39.jpg",
    zoom: null,
    content: "\n        <a href=\"mailto:sales@pbtfencing.com\">\n          <div class=\"contentLinkNone\" style=\"top:1057px;left:66px;width:263px; height:28px;\"></div>\n        </a>\n\n        <a href=\"http://www.pbtfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1057px;left:643px;width:249px; height:28px;\"></div>\n        </a>\n\n        <a href=\"https://www.instagram.com/pbt_fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1057px;left:1129px;width:343px; height:28px;\"></div>\n        </a>\n      ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"https://www.pbtfencing.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg39.jpg\">\n      </a>\n\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 39,
    subIndex: 0,
    startIndex: 0,
    original: "pg40.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 40-title\" style=\"top:171px;left:84px\" src=\"/113/en/static/_content/40-title.png\">\n\n        <img class=\"halfScale 40-line\" style=\"top:460px;left:88px\" src=\"/113/en/static/_content/40-line.png\">\n\n        <img class=\"halfScale 40-sub\" style=\"top:461px;left:129px\" src=\"/113/en/static/_content/40-sub.png\">\n\n       <img class=\"halfScale pointer 40-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/40-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax()\n          pg40Anim.fromTo(cOf(\"40-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"40-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"40-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"40-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop()\n        }\n      ",
    searchText: "INTERNATIONAL FENCING FEDER ATION ANNUAL C ONGRESS  2019 INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS IN LAUSANNE LAUSANNE, SWITZERLAND NOVEMBER 30, 2019",
    mobileHtml: "\n          <h2>2019 International Fencing Federation Annual Congress in Lausanne </h2>\n          <img src=\"/113/en/static/_mobile/pg40.jpg\" >\n          <p><strong>Lausanne, Switzerland<br>\n          November 30, 2019</strong></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 40,
    subIndex: 0,
    startIndex: 0,
    original: "pg41.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/gold-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/gold-facebook.png\">\n        </a>\n\n        <a href=\"https://www.facebook.com/pg/fie.org/photos/?tab=album&album_id=2622989907748837&__tn__=-UC-R\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:812px;left:51px\" src=\"/113/en/static/_content/41-gallery.png\">\n        </a>\n        \n        <img class=\"halfScale pointer 41-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/41-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax()\n          pg41Anim\n            .fromTo(cOf(\"41-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop()\n        }        \n      ",
    searchText: "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 2 OF 4  After exactly 20 years, the Annual Congress of the International Fencing Federation (FIE) returned to the Olympic capital, with more than 300 delegates gathered in Lausanne, at the SwissTech Convention Center. The President of the International Fencing Federation, Mr. Alisher Usmanov, welcomed, at the opening of the Congress, Mr. Thomas Bach, President of the International Olympic Committee (IOC), who addressed the Congress and handed-over to Mr. Usmanov the IOC Trophy of Olympic Values. Mr. Bach greeted the members of the Executive Committee and delegates warmly, saying: “I am happy for the many achievements of fencing and how fencing is living the Olympic Values.” Mr. Bach went on to encourage delegates to “be a part of the change you want to see.”  Tap here to link through to GALLERY  AWARDS Challenge Chevalier Feyerick Every second (odd-numbered) year, the Challenge Chevalier Feyerick is awarded to an individual fencer team or group of fencers, or member federation that, during the last two years, has shown the most chivalrous and unselfish attitude and spirit of sportsmanship and Fair Play, serving as an example to others in the future.",
    mobileHtml: "\n          <p>After exactly 20 years, the Annual Congress of the International Fencing Federation (FIE) returned to the Olympic capital, with more than 300 delegates gathered in Lausanne, at the SwissTech Convention Center.</p>\n          <p>The President of the International Fencing Federation, Mr. Alisher Usmanov, welcomed, at the opening of the Congress, Mr. Thomas Bach, President of the International Olympic Committee (IOC), who addressed the Congress and handed-over to Mr. Usmanov the IOC Trophy of Olympic Values.</p>\n          <p>Mr. Bach greeted the members of the Executive Committee and delegates warmly, saying: \u201CI am happy for the many achievements of fencing and how fencing is living the Olympic Values.\u201D Mr. Bach went on to encourage delegates to \u201Cbe a part of the change you want to see.\u201D</p>\n          <h2>Awards </h2>\n          <p><b>Challenge Chevalier Feyerick </b></p>\n          <p>Every second (odd-numbered) year, the Challenge Chevalier Feyerick is awarded to an individual fencer team or group of fencers, or member federation that, during the last two years, has shown the most chivalrous and unselfish attitude and spirit of sportsmanship and Fair Play, serving as an example to others in the future.</p>\n          <p>The Congress presented the 2019 Challenge Chevalier Feyerick to Mr. Thomas Bach.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 41,
    subIndex: 0,
    startIndex: 0,
    original: "pg42.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/gold-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/gold-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 42-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/42-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax()\n          pg42Anim\n            .fromTo(cOf(\"42-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop()\n        }  \n      ",
    searchText: "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 3 OF 4  The Congress presented the 2019 Challenge Chevalier Feyerick to Mr. Thomas Bach. Fair Play Trophy Based on the proposal of the FIE Fair Play Council, the FIE Executive Committee awards the Fair Play trophy to one or several individuals in world fencing who exhibited a significant act of fair play during the year. For 2019, the award was given to the following fencers: • the Hungarian Men’s sabre team: Tamás Decsi, Csanád Gémesi, András Szatmári, Áron Szilágyi and; • Boladé Apithy (FRA)",
    mobileHtml: "\n          <h2>Fair Play Trophy</h2>\n          <p>Based on the proposal of the FIE Fair Play Council, the FIE Executive Committee awards the Fair Play trophy to one or several individuals in world fencing who exhibited a significant act of fair play during the year. For 2019, the award was given to the following fencers:</p>\n          <p>The Hungarian Men\u2019s sabre team:</p>\n          <p>Tam\xE1s Decsi</p>\n          <p>Csan\xE1d G\xE9mesi</p>\n          <p>Andr\xE1s Szatm\xE1ri</p>\n          <p>\xC1ron Szil\xE1gyi</p>\n          <p>Bolad\xE9 Apithy (FRA)</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 42,
    subIndex: 0,
    startIndex: 0,
    original: "pg43.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/gold-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/gold-facebook.png\">\n        </a>\n        <img class=\"halfScale pointer 43-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/43-arrow.png\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('43-overlay')\"style=\"top:811px;left:55px\" src=\"/113/en/static/_content/gold-earth.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div id=\"43-overlay\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/113/en/static/_content/43-overlay.png\">\n          <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('43-overlay');\"></div>\n        </div>\n\n        ",
    script: "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax()\n          pg43Anim\n            .fromTo(cOf(\"43-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop()\n          hideOverlay('43-overlay');\n        }  \n      ",
    searchText: "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 4 OF 4  NEW MEMBER FEDERATIONS The Congress approved the final affiliation of the following countries: • Cape Verde • Kenya • Oman • Papua New Guinea The number of members federations is now 157 worldwide  Tap here to view the WORLD RANKINGS  WORLD CHAMPIONSHIP HOSTS The Congress awarded to Egypt the organisation of the 2021 Senior Fencing World Championships. For the year 2022, a call for candidatures for all the championships was launched.  Furthermore, the Congress approved the report of the Executive Committee, the financial documents and the budget for the year 2020, an increase to 30 per cent of the representation of women in the FIE Commissions beginning with the 2020-2024 quadrennium, and the possibility for World and Olympic Champions to distinguish themselves by having their names printed on the backs of their fencing jackets, respectively, in red and gold. After the closing of the event, the International Fencing Family gathered for the Congress Dinner for delegates and guests including IOC President Thomas Bach at the Olympic Museum in Lausanne. ■  W W W.FIE .ORG",
    mobileHtml: "\n          <h2>New Member Federations</h2>\n          <p>The Congress approved the final affiliation \n          of the following countries:</p>\n          <p>\u2022 \x07Cape Verde </p>\n          <p>\u2022 \x07Kenya </p>\n          <p>\u2022 \x07Oman </p>\n          <p>\u2022 \x07Papua New Guinea </p>\n          <p>The number of members federations is now 157 worldwide </p>\n          <h2>World Championship Hosts</h2>\n          <p>The Congress awarded to Egypt the organisation of the 2021 Senior Fencing World Championships. For the year 2022, a call for candidatures for all the championships \n          was launched.</p>\n          <p>Furthermore, the Congress approved the report of the Executive Committee, the financial documents and the budget for the year 2020, an increase to 30 per cent of the representation of women in the FIE Commissions beginning with the 2020-2024 quadrennium, and the possibility for World and Olympic Champions to distinguish themselves by having their names printed on the backs of their fencing jackets, respectively, in red and gold.</p>\n          <p>After the closing of the event, the International Fencing Family gathered for the Congress Dinner for delegates and guests including IOC President Thomas Bach at the Olympic Museum in Lausanne.</p>\n          <p><b>RANKING WINNERS</b></p>\n          <p>Each team and individual winner of the year\u2019s top-level world junior and senior rankings in epee, foil and sabre as well as overall nations are awarded at the Congress. This year\u2019s recipients of awards include the following:</p>\n          <p><b>Epee</b></p>\n          <p>Senior Team: <br>\n          Russia (women) <br>\n          Russia (men)</p>\n          <p>Senior Individual: <br>\n          Man Wai Vivian Kong (HKG) <br>\n          Kazuyasu Minobe (JPN)</p>\n          <p>Junior Team: <br>\n          Russia (women) <br>\n          Hungary (men)</p>\n          <p>Junior Individual: <br>\n          Federica Isola (ITA) <br>\n          Davide Di Veroli (ITA)</p>\n          <p><b>Foil</b></p>\n          <p>Senior Team: <br>\n          Russia (women) <br>\n          USA (men)</p>\n          <p>Senior Individual: <br>\n          Inna Deriglazova (RUS) <br>\n          Alessio Foconi (ITA)</p>\n          <p>Junior Team:<br>\n          Italy (women) <br>\n          Russia (men)</p>\n          <p>Junior Individual: <br>\n          Martina Favaretto (ITA) <br>\n          Mohamed Hamza (EGY)</p>\n          <p><b>Sabre</b></p>\n          <p>Senior Team: <br>\n          France (women) <br>\n          France (women) </p>\n          <p>Senior Individual:<br>\n          Olga Kharlan (UKR)\n          Sanguk Oh (KOR)</p>\n          <p>Junior Team:<br>\n          Germany (women)\n          Italy (men)</p>\n          <p>Junior Individual:<br>\n          Yoana Ilieva (BUL) <br>\n          Lorenzo Roma (ITA)</p>\n          <p><b>Nations Grand Prix</b></p>\n          <p>Seniors: Russia <br>\n          Juniors: Italy</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 43,
    subIndex: 0,
    startIndex: 0,
    original: "pg44.jpg",
    zoom: null,
    content: "",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <img src=\"/113/en/static/_mobile/pg44.jpg\">\n        \n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 44,
    subIndex: 0,
    startIndex: 0,
    original: "pg45.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale pointer 45-arrow\" style=\"top:949px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/45-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax()\n          pg45Anim\n            .fromTo(cOf(\"45-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop()\n        }  \n      ",
    searchText: "MEE T THE ATHLE TES  			 RIO & SERA  			 AZUMA",
    mobileHtml: "\n        <h2>7:1 Rio & Sera Azuma</h2>\n        <img src=\"/113/en/static/_mobile/pg45.jpg\" >\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 45,
    subIndex: 0,
    startIndex: 0,
    original: "pg46.jpg",
    zoom: null,
    content: "\n      \n        <img id=\"46-img-1\" class=\"halfScale 46-questions\" style=\"top:15px;left:16px; \" src=\"/113/en/static/_content/46-img-1.jpg\">\n        <img id=\"46-img-2\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-2.jpg\">\n        <img id=\"46-img-3\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-3.jpg\">\n        <img id=\"46-img-4\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-4.jpg\">\n        <img id=\"46-img-5\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-5.jpg\">\n        <img id=\"46-img-6\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-6.jpg\">\n        <img id=\"46-img-7\" class=\"halfScale 46-questions\" style=\"top:17px;left:20px; display: none;\" src=\"/113/en/static/_content/46-img-7.jpg\">\n\n        <img id=\"46-no-1\" class=\"halfScale 46-questions\" style=\"top:412px;left:714.5px\"; src=\"/113/en/static/_content/46-1.png\">\n        <img id=\"46-no-2\" class=\"halfScale 46-questions\" style=\"top:417px;left:728px;  display: none;\" src=\"/113/en/static/_content/46-2.png\">\n        <img id=\"46-no-3\" class=\"halfScale 46-questions\" style=\"top:417px;left:728px; display: none; \" src=\"/113/en/static/_content/46-3.png\">\n        <img id=\"46-no-4\" class=\"halfScale 46-questions\" style=\"top:417px;left:728px; display: none;\" src=\"/113/en/static/_content/46-4.png\">\n        <img id=\"46-no-5\" class=\"halfScale 46-questions\" style=\"top:417px;left:728px; display: none;\" src=\"/113/en/static/_content/46-5.png\">\n        <img id=\"46-no-6\" class=\"halfScale 46-questions\" style=\"top:417px;left:728px; display: none;\" src=\"/113/en/static/_content/46-6.png\">\n        <img id=\"46-no-7\" class=\"halfScale 46-questions\" style=\"top:417px;left:728.5px; display: none;\" src=\"/113/en/static/_content/46-7.png\">\n        \n        <div class=\"addContentLink\" style=\"top: 443px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-1', '46-img-1')\"></div>\n        <div class=\"addContentLink\" style=\"top: 538px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-2', '46-img-2')\"></div>\n        <div class=\"addContentLink\" style=\"top: 629px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-3', '46-img-3')\"></div>\n        <div class=\"addContentLink\" style=\"top: 722px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-4', '46-img-4')\"></div>\n        <div class=\"addContentLink\" style=\"top: 813px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-5', '46-img-5')\"></div>\n        <div class=\"addContentLink\" style=\"top: 907px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-6', '46-img-6')\"></div>\n        <div class=\"addContentLink\" style=\"top: 1000px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('46-no-7', '46-img-7')\"></div>\n\n        <img id=\"46-next\" class=\"halfScale pointer\" style=\"top:949px;left:651px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/46-arrow.png\">\n      ",
    script: "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax()\n          pg46Anim.fromTo(idOf(\"46-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)\n        }\n  \n        function swapQuestion(ele, img) {\n          var x = cOf(\"46-questions\");\n          var i;\n          for (i = 0; i < x.length; i++) {\n            x[i].style.display = 'none';\n          }\n          idOf(ele).style.display = \"\"\n          idOf(img).style.display = \"\"\n        }\n  \n        function onPageLeave() {\n          pg46Anim.stop()\n          removeContentLinks()\n        }\n      ",
    searchText: "Japan’s Azuma sisters, Rio (21) and Sera (20), are both competitive fencers active on the international women’s foil circuit. They became interested in fencing because of their mother, who represented Japan in the Junior and Cadet Fencing World Championships. Home from the recent Saint Maur Women’s Foil World Cup in France, the pair shared their fencing experiences with us. How is it to compete as sisters? RIO: Nothing special to me. I play just to win. SERA: Being with Rio is very reassuring, but, when fencing with her, of course, I try to do my best to win. However, as we know everything about each other, it is actually very tough to play with her.  1 2 3 4 5 6 7",
    mobileHtml: "\n          <p>Japan\u2019s Azuma sisters, Rio (21) and Sera (20), are both competitive fencers active on the international women\u2019s foil circuit. They became interested in fencing because of their mother, who represented Japan in the Junior and Cadet Fencing World Championships. Home from the recent Saint Maur Women\u2019s Foil World Cup in France, the pair shared their fencing experiences with us.</>\n          <p><b>How is it to compete as sisters?</b></p>\n          <p>Rio: Nothing special to me. I play just to win.</p>\n          <p>Sera: Being with Rio is very reassuring, but, when fencing with her, of course, I try to do my best to win. However, as we know everything about each other, it is actually very tough to play with her. </p>\n          <p><b>What was it like when you began competing internationally?</b><p/>\n          <p>Rio: I was a little bit afraid of playing with foreign fencers, as I just didn\u2019t have any experience.</p>\n          <p>Sera: I used to feel foreign fencers were very strong and they cried in a very loud voice quite often!</p>\n          <p><b>What are your goals for fencing, for each of you?</b></p>\n          <p>Rio: We will attend the Olympic Games together. </p>\n          <p>Sera: Sera: To get a gold medal in the Olympic Games.</p>\n          <p><b>What have been your best fencing experiences?</b></p>\n          <p>Rio: Playing with foreign fencers is wonderful, an experience I never thought of. </p>\n          <p>Sera: I got my first silver medal in a senior FIE World Cup last year (in Algeria), which was a wonderful experience, and hard to believe it at that moment.</p>\n          <p><b>What do you love most about fencing?</b></p>\n          <p>Rio: When I have won a game!</p>\n          <p>Sera: The feeling when winning. I feel very happy when efforts finally bear fruit.</p>\n          <p><b>What does it mean to you for the Olympic Games to be in Tokyo in 2020?</b></p>\n          <p>Rio: To attend the Olympic Games held in my country should be a lot of value for me and affect my life.</p>\n          <p>Sera: Just special, regardless of the results.</p>\n          <p><b>What message do you have for younger fencers around the world?</b></p>\n          <p>Rio & Sera (both): We are preparing very hard to get medals at the Olympic Games. We will work continuously very hard for the people who support us. Please cheer us on!</p>\n\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 46,
    subIndex: 0,
    startIndex: 0,
    original: "pg47.jpg",
    zoom: null,
    content: "",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <img src=\"/113/en/static/_mobile/pg47.jpg\">\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 47,
    subIndex: 0,
    startIndex: 0,
    original: "pg48.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 48-title\" style=\"top:828px;left:79px\" src=\"/113/en/static/_content/48-title.png\">\n\n        <img class=\"halfScale 48-line\" style=\"top:1005px;left:704px\" src=\"/113/en/static/_content/48-line.png\">\n\n        <img class=\"halfScale 48-sub\" style=\"top:994px;left:725px\" src=\"/113/en/static/_content/48-sub.png\">\n\n       <img class=\"halfScale pointer 48-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/48-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax()\n          pg48Anim.fromTo(cOf(\"48-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"48-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"48-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"48-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop()\n        }\n      ",
    searchText: "¬ FIE & NATIONAL FEDER ATION NE WS  FIE CONTEST SEEKS NEW SABRE TECHNOLOGY  LAUSANNE, SWITZERLAND NOVEMBER 25, 2019",
    mobileHtml: "\n          <h2>FIE contest seeks new sabre technology</h2>\n          <img src=\"/113/en/static/_mobile/pg48.jpg\" >\n          <p><b>Lausanne, Switzerland<br>\n          November 25, 2019</b></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 48,
    subIndex: 0,
    startIndex: 0,
    original: "pg49.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 49-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/49-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <a href=\"https://static.fie.org/uploads/23/118870-ED%2019%E2%80%9D%20Contest%20-%20Regulations%20ENG%20FINALE%20%28%20R-T%29%2018.11.2019.pdf \" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:199px;right:315px;width:219px; height:30px;\"></div>\n        </a>\n        <a href=\"https://static.fie.org/uploads/23/118876-Initial%20Request%20for%20%E2%80%9CED-19%E2%80%9D%20Contest%20Participation%20Form%20Tsukhlo%20LAST.pdf \" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:139px;right:239px;width:295px; height:30px;\"></div>\n        </a>\n\n        \n        ",
    script: "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax()\n          pg49Anim.fromTo(cOf(\"49-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 2 OF 2  The FIE is sponsoring an international contest inviting developers to create new technology for registering hits in sabre fencing. The objective is to design and manufacture a modern sensor, one that is easy to use, inexpensive and durable for competition. An FIE Contest Commission that includes members of the Executive Committee and several commissions and councils, as well sport/ technical staff, is responsible for accepting and appraising sensor prototypes.  There are specific requirements for the design. According to FIE Sport and Technical Director Evgeny Tsoukhlo, “The apparatus should not register light touches or blade contact, but rather only valid hits of the blade on an opponent”. He added, “Overall, the technology must meet the standards of sabre fencing, including both thrusting and cutting touches with the cutting edge and back of the blade. All hits made with the cutting edge, flat or back of the blade should register as valid touches. Hits with the guard are not allowed, must be annulled and the fencer making the hit is penalised. Hits made ‘through’ the blade must score as valid, meaning those that touch both the opponent’s sabre and a valid target area simultaneously.” The two accompanying documents include specific and technical details and rules of the contest, as well as a request for participation.■ Click here for Contest regulations Click here for Contest participation form  W W W.FIE .ORG",
    mobileHtml: "\n          <p>The FIE is sponsoring an international contest inviting developers to create new technology for registering hits in sabre fencing. </p>\n          <p>The objective is to design and manufacture a modern sensor, one that is easy to use, inexpensive and durable for competition. An FIE Contest Commission that includes members of the Executive Committee and several commissions and councils, as well sport/technical staff, is responsible for accepting and appraising sensor prototypes.</p>\n          <p>There are specific requirements for the design. According to FIE Sport and Technical Director Evgeny Tsoukhlo, \u201CThe apparatus should not register light touches or blade contact, but rather only valid hits of the blade on an opponent\u201D. He added, \u201COverall, the technology must meet the standards of sabre fencing, including both thrusting and cutting touches with the cutting edge and back of the blade. All hits made with the cutting edge, flat or back of the blade should register as valid touches. Hits with the guard are not allowed, must be annulled and the fencer making the hit is penalised. Hits made \u2018through\u2019 the blade must score as valid, meaning those that touch both the opponent\u2019s sabre and a valid target area simultaneously.\u201D</p>\n          <p>The two accompanying documents include specific and technical details and rules of the contest, as well as a request for participation.</p>\n          <a href=\"\" target=\"_blank\">Click here for Contest regulations</a> <br>\n          <a href=\"\" target=\"_blank\">Click here for Contest participation form</a>\n\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 49,
    subIndex: 0,
    startIndex: 0,
    original: "pg50.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 50-title\" style=\"top:85px;left:93px\" src=\"/113/en/static/_content/50-title.png\">\n\n        <img class=\"halfScale 50-line\" style=\"top:261px;left:715px\" src=\"/113/en/static/_content/50-line.png\">\n\n        <img class=\"halfScale 50-sub\" style=\"top:260px;left:754px\" src=\"/113/en/static/_content/50-sub.png\">\n\n       <img class=\"halfScale pointer 50-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/50-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax()\n          pg50Anim.fromTo(cOf(\"50-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"50-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"50-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"50-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop()\n        }\n      ",
    searchText: "¬ FIE & NATIONAL FEDER ATION NE WS  BUDAPEST COACHING ACADEMY OPEN FOR ENROLLMENT  LAUSANNE, SWITZERLAND DECEMBER 5, 2019",
    mobileHtml: "\n          <h2>Budapest Coaching Academy Open for Enrollment</h2>\n          <img src=\"/113/en/static/_mobile/pg50.jpg\" >\n          <p><b>Budapest, Hungary<br>\n          December 5, 2019</p></b>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 50,
    subIndex: 0,
    startIndex: 0,
    original: "pg51.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 51-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/51-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax()\n          pg51Anim.fromTo(cOf(\"51-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg51Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 2 OF 3  As part of the FIE development programme and ongoing commitment to expanding and enriching fencing around the world, the FIE is sponsoring the 2020 Budapest Coaching Academy. The program, open to coaches in FIE-affiliated member federations from Europe, the Americas and Asia/Oceania, includes a set of threemonth sessions—one for each weapon (epee, foil, sabre)—held throughout the year. Graduates of the program will receive an official FIE-recognised diploma.  The Budapest Coaching Academy curriculum includes classes in psychology, physiology, sport theory and biomechanics in addition to coaching education and fencing practice. Each of the three-month programs will be held in English and take place with a full-time, daily (Monday-Friday) schedule. The format of the",
    mobileHtml: "\n          <p>As part of the FIE development programme and ongoing commitment to expanding and enriching fencing around the world, the FIE is sponsoring the 2020 Budapest Coaching Academy</p>\n          <p>The program, open to coaches in FIE-affiliated member federations from Europe, the Americas and Asia/Oceania, includes a set of three-month sessions\u2014one for each weapon (epee, foil, sabre)\u2014held throughout the year. Graduates of the program will receive an official FIE-recognised diploma.</p>\n          <p>The Budapest Coaching Academy curriculum includes classes in psychology, physiology, sport theory and biomechanics in addition to coaching education and fencing practice. Each \n          of the three-month programs will be held in English and take place with a full-time, daily (Monday-Friday) schedule. The format of the program is open to eight students per weapon, including six from Europe and two from the Americas and Asia/Oceania.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 51,
    subIndex: 0,
    startIndex: 0,
    original: "pg52.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 52-arrow\" style=\"top:845px;left:1386px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/52-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <a href=\"mailto:training.camp@fie.ch\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:142px;right:489px;width:197px; height:30px;\"></div>\n        </a>\n        \n\n        \n        ",
    script: "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax()\n          pg52Anim.fromTo(cOf(\"52-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"52-line\"), 0.6, {y:52, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"52-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"52-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 3 OF 3  program is open to eight students per weapon, including six from Europe and two from the Americas and Asia/Oceania. “The FIE is dedicated to strengthening our sport as well as the effectiveness and availability of coaching”, said Evgeny Tsukhlo, FIE Sport and Technical Director. “This is one of many ways in which we are engaged in supporting our members and their efforts to continually develop fencing.” Eligible applicants to the program must meet certain requirements, notably including having at least seven years of coaching experience, a level-three coaching diploma, an FIE or national fencing license and a commitment to coaching in their national federation for a minimum of two years after graduation. Also required is written approval from each applicant’s national federation president, a biography, and other details. ■  Following is the schedule for the Academy sessions:  Epee: January 20 to April 18; application deadline has passed  Sabre: April 22 to July 20; application deadline is February 14, 2020  Foil: September 17 to December 15; application deadline is June 12, 2020 Applications must be sent from the national federations to the FIE to: training.camp@fie.ch.  W W W.FIE .ORG",
    mobileHtml: "\n          <p>\u201CThe FIE is dedicated to strengthening our sport as well as the effectiveness and availability of coaching\u201D, said Evgeny Tsukhlo, FIE Sport and Technical Director. \u201CThis is one of many ways in which we are engaged in supporting our members and their efforts to continually develop fencing.\u201D</p>\n          <p>Eligible applicants to the program must meet certain requirements, notably including having at least seven years of coaching experience, a level-three coaching diploma, an FIE or national fencing license and a commitment to coaching in their national federation for a minimum of two years after graduation. Also required is written approval from each applicant\u2019s national federation president, a biography, and other details.</p>\n          <p><b>Following is the schedule for the Academy sessions:</b></p>\n          <p>Epee: January 20 to April 18; application deadline has passed</p>\n          <p>Sabre: April 22 to July 20; application deadline is February 14, 2020</p>\n          <p>Foil: September 17 to December 15; application deadline is June 12, 2020</p>\n          <p>Applications must be sent from the national federations to the FIE to: training.camp@fie.ch.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 52,
    subIndex: 0,
    startIndex: 0,
    original: "pg53.jpg",
    zoom: null,
    content: "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:769px;left:18px;width:614px; height:43px;\"></div>\n          </a>\n\n          <a href=\"mailto:info@fencewithfun.com\">\n            <div class=\"contentLinkNone\" style=\"top:940px;left:75px;width:219px; height:28px;\"></div>\n          </a>\n\n          <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:942px;left:353px;width:214px; height:28px;\"></div>\n          </a>\n          ",
    script: "",
    searchText: "",
    mobileHtml: "\n      \n      <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n        <img src=\"/113/en/static/_mobile/pg53.jpg\">\n      </a>\n        "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 53,
    subIndex: 0,
    startIndex: 0,
    original: "pg54.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 54-title\" style=\"top:93px;left:81px\" src=\"/113/en/static/_content/54-title.png\">\n\n        <img class=\"halfScale 54-line\" style=\"top:363px;left:85px\" src=\"/113/en/static/_content/54-line.png\">\n\n        <img class=\"halfScale 54-sub\" style=\"top:363px;left:122px\" src=\"/113/en/static/_content/54-sub.png\">\n\n       <img class=\"halfScale pointer 54-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/54-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax()\n          pg54Anim.fromTo(cOf(\"54-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"54-line\"), 0.6, {y:54, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"54-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"54-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop()\n        }\n      ",
    searchText: "¬ FIE & NATIONAL FEDER ATION NE WS  DEMOS AND COMPETITIONS HELD IN TOKYO TOKYO, JAPAN DECEMBER 11, 2019",
    mobileHtml: "\n          <h2>Demos and competitions held in Tokyo</h2>\n          <img src=\"/113/en/static/_mobile/pg54.jpg\" >\n          <p><b>Tokyo, Japan<br>\n          December 11, 2019</b></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 54,
    subIndex: 0,
    startIndex: 0,
    original: "pg55.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 55-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/55-arrow.png\">\n\n        <a href=\"https://www.facebook.com/pg/fie.org/photos/?tab=album&album_id=2642671112447383&__tn__=-UC-R\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:980px;left:1233px;width:58px; height:30px;\"></div>\n          </a>\n      ",
    script: "\n        function onPageEnter() {\n          pg55Anim = new TimelineMax()\n          pg55Anim.fromTo(cOf(\"55-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg55Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 2 OF 4  The International Fencing Federation held interactive fencing exhibitions for schoolchildren in Japan as it prepares for the 2020 Tokyo Summer Olympic Games. The events took place prior to the December 13-15 Tokyo Senior Men’s Foil World Cup/ Olympic Test Event. On Sunday, December 8, a fencing demo at the Bunkyo Sports Center gave children the opportunity to try fencing with a coach and promoted the upcoming World Cup/Test Event  and 2020 Olympic Games. Several thousand students from elementary schools around Tokyo’s Bunkyo City were invited, and many schoolchildren who attended were able to experience fencing first-hand. Souvenirs and recognition were given for taking part, along with photos and opportunities to meet athletes. Photos from the event may be viewed here.",
    mobileHtml: "\n          <p>The International Fencing Federation held interactive fencing exhibitions for schoolchildren in Japan as it prepares for the 2020 Tokyo Summer Olympic Games</p>\n          <p>The events took place prior to the December 13-15 Tokyo Senior Men\u2019s Foil World Cup/Olympic Test Event.</p>\n          <p>On Sunday, December 8, a fencing demo at the Bunkyo Sports Center gave children the opportunity to try fencing with a coach and promoted the upcoming World Cup/Test Event and 2020 Olympic Games. Several thousand students from elementary schools around Tokyo\u2019s Bunkyo City were invited, and many schoolchildren who attended were able to experience fencing first-hand. Souvenirs and recognition were given for taking part, along with photos and opportunities to meet athletes. Photos from the event may be viewed \n          <a href=\"\" target=\"_blank\">here.</a></p>\n          \n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 55,
    subIndex: 0,
    startIndex: 0,
    original: "pg56.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('https://www.youtube.com/embed/soUTTfv1McQ')\" style=\"bottom:278px;left:933px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('https://www.youtube.com/embed/e71jp4xauJA')\" style=\"bottom:278px;left:1184px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n\n        <img class=\"halfScale pointer 56-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/56-arrow.png\">\n        ",
    script: "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax()\n          pg56Anim.fromTo(cOf(\"56-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg56Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 3 OF 4  “Today we had children learn about fencing,” said Sato. “They learned about the three weapons, how to cheer in the competition, and how to celebrate winning points and support the athletes. I would love for Japan to be represented at the Olympics in every weapon in both team and individual events. With the Olympics in Japan, now my family and other Japanese people can directly watch a fencing competition, and we would love to have them come and watch it live!”  CLICK TO WATCH  FENCING INITIATION #roadtoTokyo  FENCING IN THE SCHOOLS / #roadtoTokyo",
    mobileHtml: "\n          <p>On December 10, Japanese Olympic fencer Nozomi Sato, who competed in epee at the Rio and London Olympic Games, joined fencers Ikuo Furuta and Seiya Matsuura to present about 400 students with an introduction to fencing at the Sakuradai Elementary School in Chiba.</p>\n          <p>\u201CToday we had children learn about fencing,\u201D said Sato. \u201CThey learned about the three weapons, how to cheer in the competition, and how to celebrate winning points and support the athletes. I would love for Japan to be represented at the Olympics in every weapon in both team and individual events. With the Olympics in Japan, now my family and other Japanese people can directly watch a fencing competition, and we would love to have them come and watch it live!\u201D</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 56,
    subIndex: 0,
    startIndex: 0,
    original: "pg57.jpg",
    zoom: null,
    content: "<a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n\n        <img class=\"halfScale pointer 57-arrow\" style=\"top:845px;left:1386px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/57-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <a href=\"https://fie.org/competitions/2020/137\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:429px;left:643px;width:131px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg57Anim = new TimelineMax()\n          pg57Anim.fromTo(cOf(\"57-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg57Anim.stop()\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 4 OF 4  The Senior Men’s Foil World Cup, held at the Makuhari Messe in Chiba where fencing will take place at the Olympic Games, serves as the official Tokyo 2020 Test Event for fencing. More than 200 international men’s foil fencers participated. More information about the World Cup/Test Event may be found here on the FIE web site. ■  W W W.FIE .ORG",
    mobileHtml: "\n          <p>The Senior Men\u2019s Foil World Cup, held at the Makuhari Messe in Chiba where fencing will take place at the Olympic Games, serves as the official Tokyo 2020 Test Event for \n          fencing. More than 200 international men\u2019s foil fencers participated. </p>\n          <p>More information about the World Cup/Test Event may be found here on the FIE web site.</p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 57,
    subIndex: 0,
    startIndex: 0,
    original: "pg58.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 58-title\" style=\"top:128px;left:781px\" src=\"/113/en/static/_content/58-title.png\">\n\n        <img class=\"halfScale 58-line\" style=\"top:404px;left:785px\" src=\"/113/en/static/_content/58-line.png\">\n\n        <img class=\"halfScale 58-sub\" style=\"top:401px;left:822px\" src=\"/113/en/static/_content/58-sub.png\">\n\n       <img class=\"halfScale pointer 58-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/58-arrow.png\">\n       ",
    script: "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax()\n          pg58Anim.fromTo(cOf(\"58-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"58-line\"), 0.6, {y:58, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"58-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"58-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop()\n        }\n      ",
    searchText: "¬ FIE & NATIONAL FEDER ATION NE WS  ETROPOLSKI EUROPEAN SABRE CUP SOFIA, BULGARIA NOVEMBER 15-17, 2019",
    mobileHtml: "\n          <h2>Etropolski European Sabre Cup</h2>\n          <img src=\"/113/en/static/_mobile/pg58.jpg\" >\n          <p><b>Sofia, Bulgaria<br>\n          November 15-17, 2019</b></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 58,
    subIndex: 0,
    startIndex: 0,
    original: "pg59.jpg",
    zoom: null,
    content: "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/113/en/static/_content/green-twitter.png\">\n        </a>\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/113/en/static/_content/green-facebook.png\">\n        </a>\n        \n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('59-overlay')\" style=\"top:879px;left:61px\" src=\"/113/en/static/_content/green-trophy.png\">\n        \n        <img class=\"halfScale pointer 59-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/59-arrow.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div id=\"59-overlay\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/113/en/static/_content/59-overlay.png\">\n          <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('59-overlay');\"></div>\n        </div>\n        \n        ",
    script: "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax()\n          pg59Anim.fromTo(cOf(\"59-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg59Anim.stop()\n          hideOverlay('59-overlay');\n        }\n      ",
    searchText: "FIE & NATIONAL FEDERATION NEWS 2 OF 2  More than 500 fencers from 28 countries competed at the Etropolski Sabre European Cup in Sofia, Bulgaria, including both team and individual events. The competition took place at Sofia’s Asics Arena.  Tap here to see the RESULTS  The first day, November 15, included boys and girls under 14, with the individual sabre gold going to Arda Mustafa Gundogar (TUR) and Emese Domonkos (HUN). The second day featured individual cadet men’s sabre and team cadet women’s sabre, with Todor Stoychev (BUL) taking the gold for the men and Team USA winning for the girls. On the final day, Zoe Kim (USA) won the gold medal in individual cadet women’s sabre, while Team Bulgaria won team cadet men’s sabre. ■  W W W.FIE .ORG",
    mobileHtml: "\n          <p>More than 500 fencers from 28 countries competed at the Etropolski Sabre European Cup in Sofia, Bulgaria, including both team and individual events. The competition took place at Sofia\u2019s Asics Arena.</p>\n          <p>The first day, November 15, included boys and girls under 14, with the individual sabre gold going to Arda Mustafa Gundogar (TUR) and Emese Domonkos (HUN). The second day featured individual cadet men\u2019s sabre and team cadet women\u2019s sabre, with Todor Stoychev (BUL) taking the gold for the men and Team USA winning for the girls. On the final day, Zoe Kim (USA) won the gold medal in individual cadet women\u2019s sabre, while Team Bulgaria won team cadet men\u2019s sabre.</p>\n          <p><b>Overall results included the following:</b></p>\n          <p><b>Individual Under-14 Boy\u2019s Sabre: </b><br>\n          Arda Mustafa Gundogar (TUR, gold) <br>\n          Demir Cilingir (TUR, silver) <br>\n          Enache Dacian (ROM, bronze) <br>\n          Matyas Farkas (HUN, bronze)</p>\n          <p><b>Individual Under-14 Girl\u2019s Sabre: </b><br>\n          Emese Domonkos (HUN, gold) <br>\n          Zarifa Huseynova (AZE, silver) <br>\n          Kalina Atanasova (BUL, bronze) <br>\n          Damla Demirkol (TUR, bronze)</p>\n          <p><b>Individual Cadet Men\u2019s Sabre: </b><br>\n          Todor Stoychev (BUL, gold) <br>\n          Kirk Chayevsky (USA, silver) <br>\n          Colby Harley (USA, bronze) <br>\n          Oleksander Kushkov (USA, bronze)</p>\n          <p><b>Individual Cadet Women\u2019s Sabre: </b><br>\n          Zoe Kim (USA, gold) <br>\n          Alina Korolova (RUS, silver) <br>\n          Nithya Guthikonda (USA, bronze) <br>\n          Zsanett Kocacs (HUN, bronze)</p>\n          <p><b>Team Cadet Men\u2019s Sabre: </b><br>\n          Bulgaria (gold)) <br>\n          Hungary (silver) <br>\n          Hungary (silver)<br></p>\n          <p><b>Team Cadet Women\u2019s Sabre: </b><br>\n          USA (gold) <br>\n          Ukraine (silver) <br>\n          USA (bronze)<br> </p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 59,
    subIndex: 0,
    startIndex: 0,
    original: "pg60.jpg",
    zoom: null,
    content: "\n        <a href=\"https://absolutefencinggear.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1022px;left:372px;width:484px; height:47px;\"></div>\n          </a>\n          ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <a href=\"https://absolutefencinggear.com\" target=\"_blank\">\n          <img src=\"/113/en/static/_mobile/pg60.jpg\">\n        </a>\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 60,
    subIndex: 0,
    startIndex: 0,
    original: "pg61.jpg",
    zoom: null,
    content: "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:728px;left:545px;width:219px; height:28px;\"></div>\n          </a>\n\n          <a href=\"mailto:sales@gfencing.com\">\n            <div class=\"contentLinkNone\" style=\"top:728px;left:765px;width:219px; height:28px;\"></div>\n          </a>\n          ",
    script: "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    searchText: "",
    mobileHtml: "\n        <a href=\"https://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/113/en/static/_mobile/pg61.jpg\">\n        </a>\n      "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 61,
    subIndex: 0,
    startIndex: 0,
    original: "pg62.jpg",
    zoom: null,
    content: "\n        <img class=\"halfScale 62-title\" style=\"top:75px;left:84px\" src=\"/113/en/static/_content/62-title.png\">\n\n        <img class=\"halfScale pointer 62-arrow\" style=\"top:938px;left:1174px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/62-arrow.png\">\n        \n        <a href=\"https://video.eurosport.com/fencing/sofya-velikaya-fencing-is-my-miracle_vid1267642/video.shtml\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\"  style=\"bottom:642px;left:1351px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n        <a href=\"https://video.eurosport.com/fencing/60-second-pro-race-imboden-gives-insight-into-what-makes-a-world-class-fencer_vid1273346/video.shtml \" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\"  style=\"bottom:476px;left:1351px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n        <a href=\"https://video.eurosport.com/fencing/fencing-generation-inside-the-aspire-academy-in-qatar_vid1272523/video.shtml\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\"  style=\"bottom:279px;left:588px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n        <a href=\"https://video.eurosport.co.uk/fencing/face-2-face-two-time-world-champion-sofia-pozdniakova-looks-back-at-her-career_vid1270170/video.shtml\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\"  style=\"bottom:124px;left:408px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n        <a href=\"https://video.eurosport.com/fencing/i-fight-with-a-bushido-mindset-kazuyasu-minobe-on-the-noble-sport-of-fencing_vid1258763/video.shtml\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\"  style=\"bottom:550px;left:154px;\" width=\"80.4px\" height=\"77.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n        ",
    script: "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax()\n          pg62Anim.fromTo(cOf(\"62-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"62-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop()\n        }\n      ",
    searchText: "EUROSP ORT VLO G  FENCING AROUND THE WORLD Sofya Velikaya: Fencing is my miracle  ‘I fight with a Bushido mindset’ Kazuyasu Minobe on the noble sport of fencing  Tap to play  Face-2-Face: Two-time world champion Sofia Pozdniakova looks back at her career  60 Second Pro: Race Imboden on what makes a world-class fencer  Fencing Generation: Inside the Aspire Academy in Qatar  W W W.FIE .ORG",
    mobileHtml: "\n          <h2>Fencing around the world</h2>\n          <p>\u2018I fight with a Bushido mindset\u2019 \n          Kazuyasu Minobe on the noble sport of fencing.</p>\n          <p><a href=\"https://video.eurosport.com/fencing/i-fight-with-a-bushido-mindset-kazuyasu-minobe-on-the-noble-sport-of-fencing_vid1258763/video.shtml\" target=\"_blank\" >Tap to play</a></p>\n          <p><b>Face-2-Face:</b></p>\n          <p>Two-time world champion Sofia Pozdniakova looks back at her career</p>\n          <p><a href=\"https://video.eurosport.co.uk/fencing/face-2-face-two-time-world-champion-sofia-pozdniakova-looks-back-at-her-career_vid1270170/video.shtml\" target=\"_blank\" >Tap to play</a></p>\n          <p><b>Fencing Generation:</b></p>\n          <p>Inside the Aspire Academy in Qatar</p>\n          <p><a href=\"https://video.eurosport.com/fencing/fencing-generation-inside-the-aspire-academy-in-qatar_vid1272523/video.shtml\" target=\"_blank\" >Tap to play</a></p>\n          <p><b>Sofya Velikaya: </b></p>\n          <p>Fencing is my miracle</p>\n          <p><a href=\"https://video.eurosport.com/fencing/sofya-velikaya-fencing-is-my-miracle_vid1267642/video.shtml\" target=\"_blank\" >Tap to play</a></p>\n          <p><b>60 Second Pro: </b></p>\n          <p>Race Imboden on what makes a world-class fencer</p>\n          <p><a href=\"https://video.eurosport.com/fencing/60-second-pro-race-imboden-gives-insight-into-what-makes-a-world-class-fencer_vid1273346/video.shtml\" target=\"_blank\" >Tap to play</a></p>\n          "
  }], [{
    guid: "00000000-0000-0000-0000-000000000000",
    title: "",
    index: 62,
    subIndex: 0,
    startIndex: 0,
    original: "pg63.jpg",
    zoom: null,
    content: "\n        <img id=\"63-title\" class=\"halfScale\" style=\"top:81px;left:80px\" src=\"/113/en/static/_content/63-title.png\">\n\n        <img class=\"halfScale pointer 63-arrow\" style=\"top:845px;left:1251px\" onclick=\"Publish.goToNextPage()\" src=\"/113/en/static/_content/63-arrow.png\">\n        ",
    script: " \n        function onPageEnter() {\n        pg63Anim = new TimelineMax();\n        pg63Anim.fromTo(idOf(\"63-title\"), 0.5,{y:-100,opacity:0}, {y:0,opacity:1}, 1)\n        .fromTo(cOf(\"63-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1.5)\n        }\n        function onPageLeave() {\n        pg63Anim.stop()\n        }\n        ",
    searchText: "",
    mobileHtml: "\n        <p><b>COLONEL ALBERT KAYA (CGO)</b></p>\n        <p>The FIE is saddened to be informed of the passing of Colonel Albert Kaya, president of the Congolese Fencing Federation, on January 19 at the Centre Hospitalier Universitaire de Brazzaville.</p>\n        <p>On behalf of our world fencing family, we extend our deepest sympathy and condolences to Colonel Kaya\u2019s family and friends, the Congolese Fencing Federation and the African Fencing Confederation during this difficult period.\u25A0</p>\n        "
  }]],
  script: "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  mobilePages: [{
    title: "Escrime XXI No. 113",
    cssClass: "cover mobile-p1",
    hideInMenu: false,
    pageLinks: [{
      index: 0,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 2,
      subIndex: 0
    }]
  }, {
    title: "Comex",
    cssClass: "aqua",
    hideInMenu: false,
    pageLinks: [{
      index: 4,
      subIndex: 0
    }]
  }, {
    title: "Editorial",
    cssClass: "aqua",
    hideInMenu: false,
    pageLinks: [{
      index: 5,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 6,
      subIndex: 0
    }]
  }, {
    title: "Tallinn women's epee World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 7,
      subIndex: 0
    }, {
      index: 8,
      subIndex: 0
    }, {
      index: 9,
      subIndex: 0
    }]
  }, {
    title: "Bonn men's foil World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 10,
      subIndex: 0
    }, {
      index: 11,
      subIndex: 0
    }, {
      index: 12,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 13,
      subIndex: 0
    }]
  }, {
    title: "Cairo men's sabre World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 14,
      subIndex: 0
    }, {
      index: 15,
      subIndex: 0
    }]
  }, {
    title: "Berne men's epee World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 16,
      subIndex: 0
    }, {
      index: 17,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 18,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 19,
      subIndex: 0
    }]
  }, {
    title: "Orléans women's sabre World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 20,
      subIndex: 0
    }, {
      index: 21,
      subIndex: 0
    }, {
      index: 22,
      subIndex: 0
    }]
  }, {
    title: "Cairo women's foil World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 23,
      subIndex: 0
    }, {
      index: 24,
      subIndex: 0
    }, {
      index: 25,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 26,
      subIndex: 0
    }]
  }, {
    title: "Saint-Maur women's foil World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 27,
      subIndex: 0
    }, {
      index: 28,
      subIndex: 0
    }, {
      index: 29,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 30,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 31,
      subIndex: 0
    }]
  }, {
    title: "Salt Lake City women's sabre World Cup",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 32,
      subIndex: 0
    }, {
      index: 33,
      subIndex: 0
    }]
  }, {
    title: "Tokyo men's foil World Cup and Olympic test event",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 34,
      subIndex: 0
    }, {
      index: 35,
      subIndex: 0
    }, {
      index: 36,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 37,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 38,
      subIndex: 0
    }]
  }, {
    title: "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS ",
    cssClass: "gold",
    hideInMenu: false,
    pageLinks: [{
      index: 39,
      subIndex: 0
    }, {
      index: 40,
      subIndex: 0
    }, {
      index: 41,
      subIndex: 0
    }, {
      index: 42,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 43,
      subIndex: 0
    }]
  }, {
    title: "7:1 Rio & Sera Azuma",
    cssClass: "aqua",
    hideInMenu: false,
    pageLinks: [{
      index: 44,
      subIndex: 0
    }, {
      index: 45,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 46,
      subIndex: 0
    }]
  }, {
    title: "FIE contest seeks new sabre technology",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 47,
      subIndex: 0
    }, {
      index: 48,
      subIndex: 0
    }]
  }, {
    title: "Budapest Coaching Academy Open for Enrollment",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 49,
      subIndex: 0
    }, {
      index: 50,
      subIndex: 0
    }, {
      index: 51,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 52,
      subIndex: 0
    }]
  }, {
    title: "Demos and competitions held in Tokyo",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 53,
      subIndex: 0
    }, {
      index: 54,
      subIndex: 0
    }, {
      index: 55,
      subIndex: 0
    }, {
      index: 56,
      subIndex: 0
    }]
  }, {
    title: "Etropolski European Sabre Cup",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 57,
      subIndex: 0
    }, {
      index: 58,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 59,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 60,
      subIndex: 0
    }]
  }, {
    title: "Fencing around the world",
    cssClass: "yellow",
    hideInMenu: false,
    pageLinks: [{
      index: 61,
      subIndex: 0
    }]
  }, {
    title: "Obituaries",
    cssClass: "grey",
    hideInMenu: false,
    pageLinks: [{
      index: 62,
      subIndex: 0
    }]
  }],
  mobileTemplate: null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-44',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SU9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bMw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.590e4de6a4232fee03c2.js